var ThemeColors = {
  "no1butta": "#d6d3ff",
  "0": "#994360",
  "2": "#FDE0CE",
  "3": "#F0D3BB",
  "5": "#f1caa9",
  "6": "#FCDFC1",
  "10": "#F3CCA6",
  "20": "#F3C4A0",
  "21": "#FAD0B0",
  "23": "#FDCAA2",
  "30": "#ECB98D",
  "31": "#FBCFA3",
  "35": "#d08764",
  "36": "#DDA680",
  "40": "#E8B086",
  "45": "#c5835c",
  "48": "#ECBB96",
  "50": "#D1976B",
  "55": "#c37c4e",
  "60": "#C3865A",
  "65": "#c07c4f",
  "66": "#8B523B",
  "70": "#AE764C",
  "75": "#864833",
  "78": "#7B553F",
  "90": "#FEE1C6",
  "96": "#FEDCC4",
  "98": "#FAD6B7",
  "108": "#FCD0B3",
  "115": "#FFE0CA",
  "118": "#F8D1A7",
  "119": "#F9C19B",
  "126": "#F7BE97",
  "128": "#FDC995",
  "129": "#F7BB91",
  "132": "#EEBE90",
  "140": "#DEA677",
  "248": "#E5A479",
  "250": "#EEBB8C",
  "327": "#C98C58",
  "330": "#9B5A34",
  "332": "#DFA46F",
  "337": "#CE8F59",
  "340": "#C87F49",
  "350": "#AD724A",
  "351": "#DD9A68",
  "355": "#B47649",
  "356": "#95582C",
  "367": "#884C30",
  "368": "#81482A",
  "400": "#5A301D",
  "405": "#421E15",
  "0.5fairlightcool": "#e3c1a6",
  "00fairlight": "#F5E8DF",
  "00ivoire": "#f8eee7",
  "001downtownrush": "#e18563",
  "002mauvebite": "#E67891",
  "002uptownglow": "#fd987e",
  "003pinksting": "#FE4891",
  "003solsearch": "#d2755f",
  "004redflag": "#F00808",
  "005blasinblush": "#FA8D9F",
  "005peachfever": "#DF6866",
  "006citysizzle": "#D66E6D",
  "006hotchili": "#AD4039",
  "007cocoazing": "#9E5A57",
  "008hothoney": "#D89072",
  "008shadeson": "#df9b86",
  "009midnightshimmer": "#c67248",
  "01beigerose": "#f3c9b2",
  "01clearcrave": "#ffffff",
  "01darkblond": "#6a5645",
  "01light": "#E5CBB2",
  "01light/claire": "#e6ccb1",
  "01pearl": "#e5e3e1",
  "01transparent": "#f7f7f7",
  "011electricbronze": "#c04a47",
  "012summerinthecity": "#dc8f77",
  "016rust": "#cb7371",
  "017copper": "#dd8172",
  "02beigenu": "#f8d4a4",
  "02blonde": "#9e866a",
  "02ice": "#eec2be",
  "02lightmedium/claireàmoyenne": "#e6ccb1",
  "02medium": "#D4966F",
  "02mediumbrown": "#6f5234",
  "02pinkdrip": "#ff9aa1",
  "025brunette": "#bd9664",
  "03clair": "#f2cda9",
  "03": "#F8E2D2",
  "05": "#F9DBD1",
  "06": "#FBCEA8",
  "02": "#FCE2D1",
  "03darkbrown": "#775446",
  "03ivoireclair": "#F7EDD7",
  "03medium/moyenne": "#d5976e",
  "03mediumdeep": "#BA6B41",
  "03moon": "#d17070",
  "03rosebite": "#cb0054",
  "03softbrown": "#cba993",
  "04cherryswirl": "#cd0021",
  "04darkbrown": "#744d38",
  "04deep": "#603316",
  "04mediumbrown": "#bfa088",
  "04miel": "#d7a088",
  "04silk": "#e98386",
  "05beigeclair": "#f2d5c2",
  "05blackbrown": "#4e403c",
  "05deep/foncée": "#603518",
  "05ivoire": "#f6e6cd",
  "05peachquench": "#c22d32",
  "05roseenlumineur": "#fcd1c3",
  "06-rougeprofond": "#B00C0B",
  "06caramelglow": "#b44e3d",
  "06freshbeige": "#E9C0A2",
  "06jauneneutralisant": "#d6b991",
  "07-pastel": "#DFC1B9",
  "07berryhaze": "#8d4040",
  "07sable": "#dead8e",
  "08acaiglaze": "#47061a",
  "08nude": "#E3C1A8",
  "08rougepassion": "#CE1616",
  "09lattecrush": "#772e1c",
  "095ivoirerose": "#fef0df",
  "1.5lightmedium": "#E3B889",
  "10caramel": "#d8a584",
  "10espressokiss": "#471b29",
  "10ivoire": "#EEDEB9",
  "10lippy": "#c03036",
  "10smokeyblack": "#221d1d",
  "104ivoirerosé": "#ffe2cb",
  "105golden": "#C63B3B",
  "105ivoirenaturel": "#ffe8d8",
  "110awestruck": "#910737",
  "110porcelaine": "#ffdfb7",
  "113-barelysheer": "#FCC4C3",
  "115beigedoré": "#f8dcbe",
  "115founder": "#8A1643",
  "115ivoire": "#efc7a3",
  "115peppy": "#8C1818",
  "118dancer": "#D9020A",
  "120artist": "#A3013D",
  "120beigerosé": "#ebba96",
  "120punchy": "#6F1212",
  "121mielclair": "#f3d0aa",
  "125inspirer": "#C95874",
  "128beigedoré": "#f5c5a1",
  "130-rosepoudre": "#DCAFAC",
  "130beigechamois": "#f9c589",
  "130extra": "#8A0322",
  "135-perpetualrose": "#C04C63",
  "135fearless": "#51041F",
  "135rosenude": "#E7A9AC",
  "145olivedore": "#f2cda9",
  "145olivedoré": "#C49672",
  "145rogue": "#DC5C7A",
  "148-summerpink": "#E86493",
  "149bronzefoncé": "#7D5744",
  "15beige": "#f2d5b9",
  "15clair": "#FFDDC3",
  "15lover": "#994360",
  "15nudeburn": "#CC837C",
  "15peachy": "#efa391",
  "150-delicious": "#E35972",
  "155savant": "#C87780",
  "155upbeat": "#F56CA0",
  "160sultry": "#BF617B",
  "165edgy": "#A4467A",
  "19-goldenbrown": "#D5B9AE",
  "20beigeéclat": "#FCE5B2",
  "20coy": "#da7987",
  "20pioneer": "#AC1A2F",
  "20roseflash": "#FF8F8E",
  "20sable": "#F5CCA6",
  "20sun": "#fecfb1",
  "200naturelrosé": "#d4ae89",
  "202-vrairose": "#B44651",
  "21beigedore": "#dfb395",
  "21beigedoré": "#F3DDAE",
  "220beigenaturel": "#e9bfa9",
  "23sweetheart": "#fecfb1",
  "230beigesable": "#eac0aa",
  "238bronzedoré": "#dca68d",
  "24bubblegum": "#fecfb1",
  "24nude": "#F0D7A2",
  "25-basetransparente": "#FFFFFF",
  "25chocolatebrown": "#322618",
  "25fuchsiaspark": "#ED5B7A",
  "25medium": "#e5b897",
  "25redhot": "#ea1121",
  "25taffy": "#9C003B",
  "250beigeensoleillé": "#d89a81",
  "250natureldoré": "#eac7b1",
  "28softbeige": "#E5B698",
  "287-rougecouture": "#571312",
  "30coralember": "#EB4D4B",
  "30miel": "#DCA271",
  "30romantic": "#EE245E",
  "30sable": "#FAD892",
  "30unrivaled": "#ba2749",
  "300foncérosé": "#c4906b",
  "32golden": "#D7A47D",
  "325shotcaller": "#B51A2C",
  "330carameldoré": "#ce8a6c",
  "340-absoluteplum": "#8E3B49",
  "35black": "#000000",
  "35cheeky": "#cd6667",
  "35fonce": "#D9A586",
  "350caramel": "#ca8360",
  "360mocha": "#9e5e2f",
  "373-mauveforme": "#a65252",
  "376-pinkforme": "#ac4d63",
  "379-fuchsiaforme": "#b6284e",
  "388-plumforme": "#7d2033",
  "40cannelle": "#F3C987",
  "40smokeybrown": "#6d4b45",
  "40witty": "#913d4a",
  "435de-stresser": "#B75050",
  "445energizer": "#FF1121",
  "45capricious": "#ea2b5e",
  "45miel": "#E5CB95",
  "45tan": "#b97b4b",
  "455harmonizer": "#9D2A26",
  "460optimist": "#DA0059",
  "48beigeensoleille": "#d39a70",
  "48beigeensoleillé": "#F5CA86",
  "493-bloodorange": "#FA393C",
  "50-dustyrose": "#B3898B",
  "50burgundybreak": "#844F53",
  "50voyager": "#781317",
  "50wicked": "#c0262d",
  "501-rougelaque": "#821010",
  "510-redpassion": "#E42D31",
  "55royal": "#86070b",
  "56-almondrose": "#A5787B",
  "56toffee": "#CC8D65",
  "60caramel": "#DA9162",
  "60emeraldenergy": "#786B4B",
  "60poet": "#DB908A",
  "620-inthenude": "#C35961",
  "65bronze": "#C89A5A",
  "65seductress": "#C27C72",
  "70amazonian": "#B9695E",
  "coco": "#f4E7CE",
  "70cocoa": "#B06C4D",
  "70sleeplesssapphire": "#03567F",
  "701matteonyx": "#000000",
  "71blancpur": "#F1EEE8",
  "710forestbrown": "#853A02",
  "720cobalt": "#1E409C",
  "725-caramelkiss": "#944F48",
  "730emerald": "#084A41",
  "77-blancnacre": "#E4DCCF",
  "78-porcelaine": "#ECB5B0",
  "8-gonegreige": "#947678",
  "80-redesacape": "#99111B",
  "80coppernights": "#975531",
  "80ruler": "#AD4053",
  "90moonstruck": "#3A3A38",
  "90translucent": "#ffffff",
  "928uptownminimalist": "#FEDCDC",
  "930bareitall": "#EA9C87",
  "afterdark-noirintense": "#0000",
  "afterparty": "#010101",
  "allstar": "#eec590",
  "alpinesnow": "#FBFBF9",
  "amber(007),crystal(010),silk(004)&pearl(001)": "#e98b71",
  "arcticskies": "#77B5FE",
  "articskies": "#0EA8FC",
  "auroraflip": "#AC7D9C",
  "babytee": "#eb7368",
  "babytee,petalcore,wildatheart": "#eb7368",
  "barelysheer": "#FFDCE0",
  "baseblanchissante": "#FFFFFF",
  "basedevernis": "#FFFFFF",
  "baseprotectricedevernis": "#FFFFFF",
  "baserenforcatriceetprotectrice": "#FFFFFF",
  "baseteintée": "#2D1615",
  "basetransparente": "#F9F9F7",
  "berrybrunch": "#522436",
  "biglift": "#AA676E",
  "biscotticream": "#FFFF00",
  "blackbrown": "#534241",
  "blackout": "#000000",
  "orangemandarine": "#ff7f00",
  "jaunemaïs": "#f7e269",
  "safira": "#b3d0ca",
  "pétale": "#eacdd0",
  "rio": "#ecd453",
  "pékin": "#fb5043",
  "athènes": "#2a9baa",
  "paris": "#475063",
  "coton": "#fefee0",
  "blackperfecto": "#000000",
  "blacktrack": "#000000",
  "blackest-black": "#000000",
  "blancnacré": "#FCF4F6",
  "blancpur": "#F9F9F7",
  "inca": "#223b97",
  "bloodorange": "#DC2616",
  "bluedisco": "#0EA59A",
  "bluemist": "#223b97",
  "boldbrown": "#413535",
  "brownsugar": "#513529",
  "brunimmuable": "#A67A6F",
  "burgundybliss": "#6d071a",
  "burgundyboost": "#49192A",
  "champion": "#582613",
  "cherrysky": "#3B1947",
  "choco-latte": "#9A523A",
  "confident": "#d8a782",
  "coquettish": "#d0363a",
  "cosmicblack": "#000000",
  "cosmicblack-noirintense": "#000000",
  "courageous": "#d7a98f",
  "crosstheline": "#775657",
  "currentmood": "#dc7d72",
  "darkhorse": "#3b373c",
  "deeponyx": "#000000",
  "determined": "#976959",
  "discofever": "#C387BA",
  "durcilong": "#FFFFFF",
  "durcilongdiamant": "#FFFFFF",
  "electroblack": "#121313",
  "extranoir": "#000000",
  "fearless": "#c086c2",
  "fineline": "#99424A",
  "galaticcobalt": "#0000FF",
  "greenaltitude": "#303D35",
  "greenwenvy": "#0f7265",
  "grippyserum": "#ffff00",
  "hightide": "#4A5372",
  "honey": "#fece65",
  "hotpinksummer": "#cb1343",
  "icediris": "#FFC7EA",
  "inspired": "#fab3ac",
  "intensecharcoal": "#625e5b",
  "kissofshimmer": "#eebaac",
  "kneehigh": "#c26171",
  "lavenderlight": "#B369CE",
  "leather-bound": "#5C3015",
  "let'sbounce": "#7E4235",
  "lilacclouds": "#c774a6",
  "lilaclove": "#A088BC",
  "lineleader": "#CA7E80",
  "lover(15),seductress(65),artist(120),dancer(118),pioneer(20,etvoyager(50)": "#B51A2C",
  "maincharacter": "#B1343C",
  "maple": "#5c0f07",
  "mascaratear": "#854039",
  "matteonyx(701)": "#000000",
  "metablack": "#000000",
  "mutedmocha": "#826360",
  "newwave": "#CEEEF0",
  "noirintense": "#000000",
  "noirwaterproof": "#00000",
  "onit": "#925A4B",
  "outofline": "#864B46",
  "outerheaven": "#BDBCC1",
  "peachyquench": "#d75f35",
  "peaking": "#89474B",
  "pearl,silk,rust&bubblegum": "#fecfb1",
  "peonypetals": "#FDDBD4",
  "petalcore": "#e96474",
  "pinkmirage": "#e04b5b",
  "pinktoffee": "#984356",
  "player": "#AA6F69",
  "polishedwhite": "#FFFFFF",
  "porcelaine": "#FDCED8",
  "porelessjelly": "#ffff00",
  "protègeetrenforce": "#FFFFFF",
  "protègevernissèche-vite": "#FFFFFF",
  "punchypink": "#F1378C",
  "purplepop": "#EE82EE",
  "reallyrosy": "#C24D5D",
  "rebelmatt": "#000000",
  "rosefuchsia": "#EF1D64",
  "rosenu": "#C76F7B",
  "rosesalsa": "#F10B2F",
  "rougecouture": "#5F1F24",
  "rougelacqué": "#7C000D",
  "rougepassion": "#B3001E",
  "rougeprofond": "#93000F",
  "seaglass": "#71A36F",
  "sérumdecroissance22": "#FFFFFF",
  "skylinesteel": "#6C7175",
  "smoothwalnut": "#644540",
  "softbrown": "#5b3c11",
  "spacediamond": "#E6E6E6",
  "spacegraphite": "#BB96BF",
  "spicyred": "#bb0113",
  "spritzyorange": "#d03218",
  "starstudded": "#ede3c5",
  "stardustchrome": "#E1E4F4",
  "strikingnavy": "#1e2b4b",
  "superlockbrowglue": "#000000",
  "tiger'seyes": "#744337",
  "toast": "#5e2820",
  "toasted": "#BC6B4D",
  "toffee": "#ac5137",
  "topcoat3deffect": "#FFFFFF",
  "topcoateffetgel3d": "#FFFFFF",
  "topcoatséchagerapide": "#FFFFFF",
  "twinkletoes": "#E9A9A8",
  "ultrapink": "#FD6C9E",
  "underthesea": "#0065a5",
  "unique": "#dd3b7a",
  "vert": "#A7B782",
  "veryblack": "#000000",
  "veryblack&burgundyhaze": "#723650",
  "veryblackwaterproof": "#000000",
  "vividgreen": "#00FF00",
  "vrairose": "#EBC8CF",
  "warmbrown": "#775947",
  "whitecanvas": "#F5F5F3",
  "wildatheart": "#962736",
  "ubuttawerk": "#e8ced3",
  "brightandbutta": "#e5d7c0",
  "silk": "#C1BAAC",
  "irisé": "#D8C4D2",
  "nudebrun": "#9E7A6A",
  "peauxclaires": "#F2D0A9",
  "peauxmédiums": "#C68E17",
  "peauxmates": "#6E4B3A",
  "roselumière": "#F6D1D1",
  "rosedolcevita": "#D1A0A1",
  "blushboisderose": "#D2A2A1",
  "blushcorail": "#F06A61",
  "coquelicotmat": "#F04F44",
  "darling-prunelumineux": "#EA756C",
  "romance-vieuxrose": "#e04b62",
  "firstkiss-cranberry": "#C03A43",
  "beautiful-rosebonbon": "#E9A4B6",
  "adore-nudepêche": "#F9BEB9",
  "lovely-rougeorangé": "#9D605D",
  "whimsical-rosefoncé": "#B0595D",
  "charming-rosebordeaux": "#B63C51",
  "divine-bordeaux": "#9A1130",
  "hayley-rougefatal": "#BE201F",
  "glamourous-rougelumineux": "#E62B0D",
  "playful-rougeclassique": "#CA1924",
  "brownsugar-marron": "#5E3D29",
  "olive-vertfoncé": "#39402C",
  "kalamata-marronfoncé": "#412D24",
  "icing-roseclair": "#FAD5CA",
  "crush-corail": "#EA756C",
  "darkbrunette": "#543832",
  "sweetheart-roseintense": "#ea4e6f",
  "liquorice-noirintense": "#000000",
  "oysterblue-ardoise": "#788083",
  "bella-mauve": "#A0466B",
  "xoxo-rosenude": "#D99496",
  "blush-rosenude": "#B87677",
  "saddle-nudemoyen": "#A66353",
  "rosewood-boisrose": "#D5aaae",
  "aqua-turquoiseirisé": "#1280AD",
  "blacktruffle-noiririsé": "#3A3D3B",
  "goldmocha-mochacuivréirisé": "#37240A",
  "pine-vertsapinirisé": "#004924",
  "neonrose-rosebubblegum": "#E6427A",
  "ruby-cerise": "#A64C4C",
  "ash-cendré": "#7C6459",
  "mink-taupe": "#B59786",
  "greensmoke-vertfumé": "#5B6F64",
  "transparent": "#C5C5C5",
  "holographic-pailleté": "#C5C5C5",
  "blueglitter-bleupailleté": "#005789",
  "redglitter-rougepailleté": "#ad0000",
  "goldglitter-dorépailleté": "#a47a47",
  "kissed-roséeactivéeparleph": "#FF7DA7",
  "blueberry-myrtille": "#27274C",
  "eggplant-aubergine": "#512F5B",
  "hush-brunrosé": "#925d51",
  "nutmeg-nudecaramel": "#a15e4c",
  "rougerosemat": "#C84E61",
  "levrairougemat": "#B22222",
  "rougepassionmat": "#C1272D",
  "rougeroyalmat": "#9B111E",
  "figuemat": "#6C1C26",
  "corailbrillant": "#FF7F50",
  "rosevintagebrillant": "#D76D76",
  "boisderoseglossy": "#C08081",
  "nudemokaglossy": "#6F4F37",
  "rougeprune": "#70193D",
  "orange-rust": "#C65D36",
  "orange-sunset": "#FF5C00",
  "botanic-garden": "#1C3A31",
  "chocolate": "#3E2723",
  "bleu-azur": "#4F8FC2",
  "bleu-pastel": "#A1C6EA",
  "agon": "#A4C639",
  "chausey": "#00A3A6",
  "hauteville": "#7D5A5A",
  "coutainville": "#A0B5B7",
  "pirou": "#F1D5B3",
  "barneville": "#D0B0A2",
  "gouville": "#6E7464",
  "blainville": "#6F9D7C",
  "magenta": "#FF00FF",
  "abyssblue": "#003B5C",
  "agategrey": "#A9A9A9",
  "agategreynatural": "#D3D3D3",
  "apricot": "#FBAB60",
  "armygreen": "#4B5320",
  "autumncb": "#DDA15E",
  "azulejosblue": "#0077B6",
  "azurblue": "#0D3B66",
  "basswood": "#D5B89D",
  "biggreychecks": "#B8B8B8",
  "birchbeige": "#D8C9A3",
  "blackivory": "#D9D9D6",  
  "blackoffwhite": "#F5F5F5",  
  "blackwhite": "#FFFFFF",  
  "blanc": "#FFFFFF",  
  "bluebleached": "#8FBC8F",  
  "bluestripespatch": "#2E3A87",
  "brownchecks": "#8B4513",  
  "burgundynavy": "#8C1C1C",  
  "camogreen": "#78866B",  
  "canaribleached": "#FFF700",  
  "canvasbeige": "#F1E1C6",  
  "carbonblue": "#2F5061",  
  "carbonwashed": "#A8B8C2",  
  "chesnutivory": "#A46E4E",  
  "chevponderosapine": "#6B8E23",  
  "chevronwarmmole": "#8B6E4E",  
  "chiliwaterlily": "#A52A2A",  
  "clay": "#B66E41",  
  "coral": "#FF7F50",  
  "covebluenatural": "#3B9E9F",
  "darkheathergrey": "#4F4F4F",  
  "darkmauve": "#9E6A62",
  "darknavyivory": "#A5A5A5",  
  "darknavyoffwhite": "#F1F1F1",
  "darknavywhite": "#FFFFFF",
  "deepblue": "#303B71",
  "denimbleached": "#A6C1D1",
  "denimmedium": "#4F6D7A",
  "denimmediumblue": "#2A4D77",
  "denimpatchwork": "#5D8AA8",
  "englishpink": "#F4C8D4",  
  "englishpinkbleach": "#F9C1D1",  
  "englishpinkwashed": "#F1A7C1",
  "fuchsia": "#FF00FF",
  "gingerroot": "#A25C3D",
  "greekblue": "#0077BE",
  "greenpinkbeige": "#5D5E60",
  "gresblack": "#2A2A2A",
  "greypatchplaid": "#A9A9A9",
  "heartjacquard": "#FFB6C1",
  "heatherbeige": "#F1E0C6",
  "heatherhavana": "#7F4B3A",
  "heatherskyblue": "#B3CDE0",
  "hotgrey": "#8B8B8B",
  "icedcoffee": "#6F4F28",
  "indianpink": "#D46A6A",
  "indianpinkwashed": "#EAB9B9",
  "ivory": "#FFFFFF",
  "ivoryabyssblue": "#D5D6D3",
  "ivoryarmygreen": "#C1D8A0",
  "ivoryarmygreenptc": "#A8C1A1",
  "ivoryblack": "#B9B9B9",
  "ivoryburgundy": "#C3A4A0",
  "ivorydarknavy": "#A6B8D0",
  "ivorylightkhaki": "#D2D59E",
  "ivorynavy": "#A1C6E7",
  "ivorynavypatchwork": "#9BB9D7",
  "ivorypestogreen": "#B5C08D",
  "ivoryrasberry": "#E9A6A4",
  "ivorystripes": "#A1A1A1",
  "jacquardluck": "#A8D8B9",
  "jacquardwool": "#9E9E9E",
  "jalapeno": "#5F2D06",
  "khaki": "#F0E68C",
  "khakigreen": "#8E7C44",
  "lightheathergrey": "#D3D3D3",
  "lightkhaki": "#BDB76B",
  "linenlightbluest": "#B0E0E6",
  "lollipop": "#FF69B4",
  "magentableached": "#D84B8D",
  "malachitegreen": "#0BDA51",
  "mastic": "#E0B97C",
  "mediumbluedenim": "#4C6A92",
  "mediumgreywashed": "#BEBEBE",
  "mediumheathergrey": "#B5B8B1",
  "mermaid": "#7F9E7F",
  "midnightblue": "#191970",
  "midnightbluewhite": "#A9A9A9",
  "militarygreen": "#4B5320",
  "miniseerblue": "#1E90FF",
  "moledcb": "#7C4A3A",
  "monacblue": "#1D3557",
  "multicostripes": "#9B59B6",
  "navyivory": "#B0C4DE",
  "navyoffwhite": "#DCDCDC",
  "navypinkoffwhite": "#F4A6D7",
  "nocturalblue": "#2C3E50",
  "nocturnalbluevanil": "#B4C9D0",
  "nocturnalbluewash": "#3B4C6B",
  "noir": "#000000",
  "oatmealbeige": "#F0E1B6",
  "offwhite": "#F8F8FF",
  "offwhiteblack": "#E0E0E0",
  "offwhitejalapeno": "#E4B96D",
  "offwhitepoppy": "#F6D2C3",
  "offwhitevanilla": "#F3E1D4",
  "olivegreen": "#6B8E23",
  "opalinegreen": "#7FFFD4",
  "oxbrushedskyblue": "#B0E0E6",
  "oxbrushedstripes": "#A1B0B0",
  "oxpatchworkblue": "#3D5A80",
  "oxfordbluepatch": "#37474F",
  "palesauge": "#B9E3D1",
  "pastelblue": "#AEC6CF",
  "patchstripesblue": "#4B5D67",
  "patchworkbluewhite": "#A8B9D9",
  "patchworkox": "#E4E4E4",
  "patchworkpoplin": "#A0B1C2",
  "pestogreen": "#6A4C33",
  "pestogreencb": "#3D3D3D",
  "pestogreenwashed": "#D4B78C",
  "pinkgreenbeige": "#9C8C6B",
  "pinkivory": "#F8D7D6",
  "pinkmultico": "#F1A1C3",
  "pinksalt": "#F1D1DC",
  "plumcb": "#8E4D62",
  "ponderosapine": "#5D8A3C",
  "ponderosapinecb": "#59724C",
  "ponderosaskyblue": "#5A9EBD",
  "poolblue": "#40E0D0",
  "poppatchblue": "#FF69B4",
  "poppy": "#FF6347",
  "purplestripespatch": "#8A2BE2",
  "rosebeige": "#D4A5A5",  
  "rosewood": "#65000B",
  "rustblue": "#6A4E23",
  "ruststripepatch": "#6F4F28",  
  "saffronyellow": "#F4C430",
  "sagegreen": "#9DC183",
  "sandshellbeige": "#E5C8A6",
  "saratogablue": "#2B3A42",
  "seabreeze": "#98AFC7",
  "tealeaf": "#A0D6B4",
  "turquoise": "#40E0D0",
  "vibrantblueremix": "#367BB1",
  "vividblack": "#0A0A0A",
  "vividbluesky": "#1F75FE",
  "warmbeige": "#D4C4A8",
  "warmkhaki": "#9E7C1E",
  "warmmauve": "#9E7A7D",
  "warmrose": "#F9C7B6",
  "warmwood": "#7E5E4F",
  "watermelon": "#FF6347",
  "white": "#FFFFFF",
  "whitesand": "#F4F1EE",
  "wheat": "#F5DEB3",
  "wheatwashed": "#D9C79C",
  "yellowgreen": "#9ACD32",
  "nuderosé": "#EAC5AD",
  "bleuatoll": "#6CBCE5",
  "bleunacré": "#625DB5",
  "denimbleu": "#21618C",
  "linblanc": "#F8F9F9",
  "bleumoyen": "#3498DB",
  "naturel": "#C2B280",
  "natureljasmine": "#D6CBBF",
  "bleuminéral": "#586E7D",
  "grisbéton": "#9C9B97",
  "vertcanard": "#5E7A6C",
  "clair": "#E6B594",
  "moyenclair": "#D9AA81",
  "moyen": "#D49B78",
  "moyenfoncé": "#C6895D",
  "baltic": "#043253",
  "foncé": "#B77953",
  "sandstone": "#F0E4D2",
  "sangria": "#B7274E",
  "vertkenya": "#4B7757",
  "vertanglais": "#228B22",
  "kraft": "#D5B59C",
  "zèbre": "#000000",
  "slategreen": "#69785F",
  "sage": "#B6C5B8",
  "trèsfoncé": "#804521",
  "moyenneutre": "#E2B190",
  "rosegrès": "#D98A8D",
  "rosefaïence": "#BA6B66",
  "ocreor": "#DE806E",
  "soleilrousillon": "#BE896B",
  "soleilrustrel": "#A97660",
  "beigenu": "#E5BDA1",
  "biege-ecru-rosefoncé": "#E5BDA1",
  "beigefoncé": "#E5BDA1",
  "skin": "#E5BDA1",
  "beigerose": "#D49D88",
  "beigedoré": "#DA9D82",
  "mieldoré": "#C18F79",
  "ambredoré": "#BE8467",
  "garriguesautomne": "#6B4D4F",
  "vertolivier": "#4D4C36",
  "corailgigaro": "#FB656C",
  "roseorgeat": "#F8E7E9",
  "prunevalensole": "#3E1D14",
  "rosecalisson": "#F1CDCD",
  "dragée": "#F2F1ED",
  "figuesauvage": "#712C42",
  "roserestanque": "#C83F49",
  "rougeramatuelle": "#E40219",
  "rougetomette": "#AC0A1A",
  "rougeintense": "#AC0A1A",
  "orangearlésien": "#F23101",
  "epislavande": "#B8A0D0",
  "coquelicotlubéron": "#E11B00",
  "curaçao": "#B3C2C6",
  "bleupastel": "#8FA3AA",
  "lagon-in-ecru": "#35828F",
  "cosmo": "#D5B0B1",
  "kahlua": "#D7B48B",
  "basil": "#506C5E",
  "rosepastel": "#D5B7A7",
  "menthepastel": "#B9C4BB",
  "bleuocéan": "#434752",
  "trufa": "#887568",
  "grisplatine": "#484A49",
  "elephant": "#BCBDB9",
  "mauvepastel": "#B19B95",
  "plainskyway": "#ce8dfc",
  "grisnuage": "#595957",
  "nata": "#E2D8CC",
  "taupebobo": "#8E7D75",
  "forest": "#6F7160",
  "oeildetaureau": "#6E573C",
  "quartz": "#E9C0D2",
  "lemonchiffon": "#fffacd",
  "mistyrose": "#ffe4e1",
  "skyblue": "#87ceeb",
  "amethyste": "#884da7",
  "autumnleaf": "#6D3118",
  "walnutbrown": "#211913",
  "inkblack": "#1C1C1C",
  "imperialred": "#790D20",
  "ferngreen": "#3C3B29",
  "carminered": "#54101B",
  "peacockgreen": "#023C43",
  "chocolatebrown": "#35211A",
  "mossgreen": "#233228",
  "redcurrant": "#650210",
  "orangetiles": "#F5974D",
  "pétrole": "#045241",
  "vertkira": "#218E76",
  "vertjacquard": "#165A64",
  "vertmat": "#165A64",
  "vertsatine": "#165A64",
  "verts": "#165A64",
  "imperialcarminered": "#750E27",
  "sundial": "#ddb12c",
  "rosepâle": "#FFB6C1",
  "fernmossgreen": "#5A5947",
  "macadamia": "#BB9C7C",
  "citronvert": "#E7FA86",
  "jaunepastel": "#fdfd96",
  "roselayette": "#FFCEFE",
  "bleulayette": "#CEE4E6",
  "bleupersan": "#A0C1C0",
  "majorelle": "#2761C0",
  "roseélectrique": "#EE7AC7",
  "bleuélectrique": "#062FFA",
  "écru": "#FEFEE0",
  "chanvre": "#ede7d1",
  "câblechanvre": "#ede7d1",
  "bleupaon": "#423D60",
  "doree": "#dbd45e",
  "acierinoxydabledoré": "#dbd45e",
  "câbledoree": "#dbd45e",
  "maldives": "#90EDDB",
  "rosedragée": "#FAE7DF",
  "rosedragé": "#FAE7DF",
  "rosepêche": "#F8B79B",
  "pastel": "#C6D1FF",
  "vétiver": "#23A429",
  "pêche": "#f2dbb3",
  "dragé": "#EE6E6E",
  "beigepoudré": "#F1BA6A",
  "nuitétoilée": "#404195",
  "navyblue": "#33597A",
  "navy-bleu": "#33597A",
  "myrtamazarine": "#33597A",
  "navy-bleuraw": "#031f45",
  "lemon": "#FBF178",
  "burningsand": "#FBBD78",
  "mint": "#B1E4E7",
  "lightcamel": "#E1B981",
  "chamel": "#E1B981",
  "chameau": "#E1B981",
  "camellézard": "#bf8a3d",
  "dustypink": "#EEC1DD",
  "powderpink": "#ECDFE7",
  "jaunevintage": "#FFFF00",
  "jute": "#C0957B",
  "taupegold": "#b29146",
  "vertpaon": "#7DB1C1",
  "vertgris": "#7DB1C1",
  "caramel/camel": "#7e3300",
  "choco/jaune": "#5a3a22",
  "jaunepoussin": "#f8db1b",
  "jaunemoutarde": "#E1AD01",
  "mixprintbanana": "#f8db1b",
  "rainbowbanana": "#f8db1b",
  "plainbanana": "#f8db1b",
  "kaki/blanc": "#6e622b",
  "suedekaki": "#6e622b",
  "crépi/mauve": "#C0C0C0",
  "mauve": "#D473D4",
  "bleu/argent": "#C0C0C0",
  "bordeaux/rose": "#fd6c9e",
  "jean/camel": "#1b306b",
  "bronze/multico": "#614e1a",
  "noirblanc": "#000000",
  "piednoir": "#000000",
  "daimcôtelénoir": "#000000",
  "noir/noir": "#000000",
  "jaune/caramel": "#ffffe0",
  "rose/caramel": "#b78792",
  "roseantic": "#b78792",
  "holographic": "#CECECE",
  "marron/taupe": "#734838",
  "marron-roseantic-nude": "#734838", 
  "Panthère": "#734838",
  "marronclair": "#b8978c",
  "marron/rouge/bleu": "#734838",
  "cuirmarron": "#734838",
  "nuts": "#734838",
  "cuirchocolat": "#5a3d3d",
  "kaki/roccia": "#766722",
  "gris/beige": "#909090",
  "grègegrainé": "#909090",
  "bordeaux/vert": "#45150d",
  "camel/flake": "#bf8a3d",
  "camel/kaki": "#bf8a3d",
  "caramel/bordeaux": "#b87a59",
  "crépi/tourmaline": "#ddcdba",
  "camel/vert": "#b1e4c8",
  "nutela": "#6c3b1e",
  "nutella": "#6c3b1e",
  "rosecarameltaupe": "#d36e70",
  "taupe/camel": "#8d7268",
  "blanccrème": "#f7f4e4",
  "créme": "#fdf1b8",
  "rougevif": "#FF0000",
  "crocorouge": "#FF0000",
  "coganclézard": "#bb6144",
  "bleufoncé": "#0f056b",
  "bleufoncé-camel": "#0f056b",
  "rougefoncé": "#850606",
  "boisrouge": "#850606",
  "marineviolet": "#9400D3",
  "paisley": "#9400D3",
  "orchidée": "#EE82EE",
  "bleucéleste": "#26c4ec",
  "céleste": "#26c4ec",
  "malachite": "#1FA055",
  "or/argent": "#EEEBB9",
  "orblanc750/1000": "#c9c6bf",
  "orjaune750/1000": "#ffd700",
  "orrose585/1000": "#b76e79",
  "orrose750/1000": "#b76e80",
  "argent/or": "#CECB9E",
  "nuderose": "#F6D1D7",
  "fuxia": "#F344A3",
  "fuxiamulti": "#F344A3",
  "militaire": "#625510",
  "rosecendre": "#E4C0C6",
  "rosemulti": "#DFA3AD",
  "roseblush": "#DFA3AD",
  "roseqwartz": "#DFA3AD",
  "galet": "#CCCFCA",
  "bleuardoise": "#B4DADF",
  "blueshadow": "#B4DADF",
  "noircamo": "#000000",
  "noir-ecru-galetrosé": "#000000",
  "noir-lézard": "#000000",
  "noirfeuille": "#000000",
  "spinellenoire": "#000000",
  "noir-nudeclair-nudefoncé": "#000000",
  "marrontigre": "#885A18",
  "chataigne": "#885A18",
  "noirleopard": "#5B421D",
  "kakicamo": "#625510",
  "bleucamo": "#021836",
  "vermillon": "#DA5B3F",
  "vertpin": "#268A08",
  "vertprovencalpois": "#268A08",
  "greenstripes": "#268A08",
  "vertbeige": "#D1DF48",
  "ecruourson": "#F7EFE4",
  "ecruprunes": "#F1E2CD",
  "latte": "#AA9A7E",
  "lattefigues": "#A59880",
  "mochafigues": "#C09265",
  "ombre": "#B9AEA3",
  "ombreprunes": "#9D9B8C",
  "taupeprunes": "#7C6E56",
  "greigeprunes": "#9A8A6E",
  "kakiprunes": "#BDB898",
  "neutral": "#F1EADE",
  "tourmaline rose": "#e57eaf",
  "ecrubanana": "#F3EFE8",
  "neutralbanana": "#EAE2C2",
  "aubepine": "#f7cecb",
  "brume": "#e3dddc",
  "neige": "#fffde3",
  "laurier": "#bdb54b",
  "celeste": "#20968d",
  "capucine": "#e64371",
  "puce": "#2e0b09",
  "samalac": "#2f4034",
  "thumalac": "#e3e3b6",
  "lac": "#cad8e3",
  "sajalac": "#cad8e3",
  "macchiato": "#473833",
  "pionankin": "#f0e3b1",
  "caleihorizon": "#a3acb5",
  "dosconankin": "#d6c47e",
  "cypres": "#314530",
  "paille": "#f0ebc5",
  "grigri": "#a8a8a2",
  "epicurcuma": "#f5da9d",
  "bandhanapetale": "#f5cbea",
  "bloomlac": "#a7c0cc",
  "masticbanana": "#E5E1D2",
  "lattebanana": "#D3B993",
  "boreale": "#25a0db",
  "astral": "#b4c9d4",
  "floral": "#f5c1d8",
  "equator": "#B49C7B",
  "cafe": "#D5B566",
  "plaincafecreme": "#D5B566",
  "oeildetigre": "#D5B566",
  "oeildetigre/gold": "#D5B566",
  "oeildetigre/silver": "#D5B566",
  "choco": "#5a3a22",
  "rayebordeauxblanc": "#F5F5F5",
  "rayebleublancrouge": "#1F38A9",
  "rayemarineblanc": "#021836",
  "fasayprairie": "#78DCE1",
  "cielgris": "#585351",
  "norimazarine": "#F2CA2C",
  "fasayaperol": "#E1931D",
  "noirbordeaux": "#000000",
  "cuirnoir": "#000000",
  "kirefrostygreen": "#CECECE",
  "rosesakura": "#D36E70",
  "noirnuit": "#000000",
  "noircadre": "#000000",
  "blanccadre": "#F5F5F5",
  "cubes": "#000000",
  "cielkaki": "#C2E1E8",
  "marinebordeaux": "#861E15",
  "marronkakibeige": "#ede8df",
  "rayekakimarine": "#797640",
  "moutardeterracotta": "#B49B17",
  "marinepistache": "#8FD17F",
  "pistache": "#7edfe6",
  "lunebleue": "#248585",
  "curry": "#d6a332",
  "blanccassé": "#fefee2",
  "rouxcappuccino": "#ad4f09",
  "etaminemauvetalc": "#CEACE8",
  "gaufrenoirbordeauxmarine": "#861E15",
  "menthemauvetalc": "#C7EAAF",
  "moulinebeigevert": "#9A3817",
  "tricolorepaillette": "#D996B7",
  "café": "#9e8054",
  "tricolorepaillette2": "#C2E1E8",
  "tricolorepaillette3": "#F1E6C8",
  "fuschiaviolet": "#CEACE8",
  "violetmarine": "#BD9DD6",
  "moulinemarinerose": "#89274B",
  "carreauxmulticolores": "#F0E3A1",
  "talcetamine": "#E783A4",
  "gaufremarineetamine": "#0B3299",
  "gaufretalcetamine": "#FCB8C8",
  "vertanis": "#D1DF48",
  "plaquéorzirconvert": "#039E03",
  "plaquéorzirconrose": "#FFB6C1",
  "plaquéorzirconblanc": "#FFFFFF",
  "jasminewhite": "#FFFFFF",
  "zirconsblancs": "#FFFFFF",
  "câbleblanc": "#FFFFFF",
  "laitonorzirconsblancs": "#FFFFFF",
  "argentzirconsblancs": "#FFFFFF",
  "argentcaméléon": "#b4b6b8",
  "plaquéoretzirconsblancs": "#FFFFFF",
  "laitonorzirconsverts": "#039E03",
  "vertcaméléon": "#039E03",
  "zirconsverts": "#039E03",
  "laitonorzirconrose": "#FFB6C1",
  "acierinoxidableargentrose": "#FFB6C1",
  "acierinoxidableargentjaune": "#FFFF00",
  "acierinoxidableargentrouge": "#FF0000",
  "laitonorzirconsroses": "#FFB6C1",
  "laitonorzirconsmulti": "#904D0A",
  "laitonargentézirconsmulti": "#904D0A",
  "plaquéorzirconviolet": "#EE82EE",
  "argentzirconblanc": "#FFFFFF",
  "plaquéorzirconkaki": "#F0E68C",
  "argentzirconvert": "#039E03",
  "orrose": "#B4918F",
  "plaquéorrose": "#B4918F",
  "plaquéorzirconsnoirs": "#000000",
  "câblenoir": "#000000",
  "pdpbleu": "#1F38A9",
  "pdpgris": "#585351",
  "crochet": "#F1E6C8",
  "beigeroserouge": "#F1E6C8",
  "lilarosesable": "#E73E01",
  "marinebleu": "#021836",
  "gaufremarinegris": "#585351",
  "gaufrebeigemarron": "#E4DCC9",
  "noir-bordeaux-marron": "#4D2E0F",
  "rayemarinebeige": "#A3DCDC",
  "moulineorangevert": "#D65C1B",
  "moulinemarinebeige": "#D65C1B",
  "tricoloremarinebleu": "#0B3299",
  "tricolorekakibleu": "#797640",
  "gaufremarinerose": "#FCB8C8",
  "moulinecielmarine": "#AED2D2",
  "noisette": "#904D0A",
  "multicolore6": "#904D0A",
  "multicolore5": "#797640",
  "multicolore7": "#F4E670",
  "bleutropico": "#1051a1",
  "bleustone": "#1051a1",
  "corailpop": "#e6390e",
  "anthracite": "#585351",
  "grischinemarine": "#87807B",
  "camelclair": "#E1D9C3",
  "rayebeige/camel": "#E1D9C3",
  "camellezard": "#E1D9C3",
  "contour": "#F5F5F5",
  "olivetranslucide": "#558E0E",
  "vin": "#A4285F",
  "whisky": "#A9431F",
  "whiskykaki": "#9A3817",
  "plein": "#1F38A9",
  "sienne": "#E76A30",
  "roseraye": "#F470DE",
  "bleuraye": "#AED2D2",
  "ivoirejade": "#C2DFD6",
  "sauge": "#B1DACD",
  "rayebleubeige": "#A3DCDC",
  "doretranslucide": "#F4E670",
  "doreecaille": "#87807B",
  "noirecaille": "#000000",
  "ecaillekaki": "#797640",
  "oliveclair": "#558E0E",
  "gristranslucide": "#87807B",
  "rosetranslucide": "#FCB8C8",
  "ecaillerose": "#F470DE",
  "vintranslucide": "#A4285F",
  "vintranslucide2": "#95154D",
  "ecailletranslucide": "#C08764",
  "translucideecaille": "#C08764",
  "bleumarbre": "#5E97AF",
  "ecailleclaire": "#A27C2A",
  "ecaillebleue": "#236CE5",
  "ecaille": "#8C6001",
  "ecailleeffetbleute": "#6C320F",
  "grismarbre": "#87807B",
  "terracottablanc": "#CB5414",
  "mimosablanc": "#F3E449",
  "jaunemimosa": "#F3E449",
  "jauneraye": "#F3E449",
  "blancmarine": "#0B3299",
  "zebre": "#000000",
  "noirleo": "#000000",
  "orclair": "#FFE565",
  "améthyste": "#672F92",
  "améthyste/gold": "#672F92",
  "améthyste/silver": "#672F92",
  "sunnylace": "#F6EC1F",
  "rosequartz": "#FCB8C8",
  "noirsable": "#E1D9C3",
  "grenade": "#BF264B",
  "vertémeraude": "#26BF75",
  "vertbouteille": "#096a09",
  "vertempire": "#139C1B",
  "strass": "#E5E7E9",
  "roselurex": "#F7E0F0",
  "grislurex": "#C4C1C3",
  "cerisierlurex": "#E94181",
  "dentellegrenadine": "#E94181",
  "rainbowlace": "#F4D3E0",
  "veloursmarine": "#03224C",
  "magicforest": "#37D782",
  "blushlurex": "#E9D0D0",
  "dentelleblush": "#F3EEEE",
  "vichynoir": "#000000",
  "blackgold": "#2C2C2B",
  "dentellenoire": "#000000",
  "blacksilver": "#000000",
  "black": "#000000",
  "coal": "#000000",
  "molletonnoir": "#000000",
  "blueliberty": "#14C3DC",
  "paon": "#083C7A",
  "lurexstripes": "#9B939B",
  "aciercocoon": "#323232",
  "ecrucocoon": "#FBF6F6",
  "marinrouge": "#DF0707",
  "fireflowers": "#2B6D38",
  "flowersnuts": "#CD6315",
  "veloursnoisette": "#E58C03",
  "summerflowers": "#F391F3",
  "pâquerettes": "#E74A14",
  "kakistripes": "#797640",
  "amethyst": "#e4cbf7",
  "aubergine": "#251C55",
  "dolphin": "#939c91",
  "opale": "#d0e3cc",
  "opal": "#b8dbe0",
  "cobalt": "#2d25ba",
  "twiganectar": "#F1E6C8",
  "wavynectar": "#B9541B",
  "beige": "#F1E6C8",
  "peau": "#F1E6C8",
  "bougainvilliers": "#561e46",
  "beigechiné": "#F1E6C8",
  "suedebeige": "#F1E6C8",
  "beigeetbleu": "#F1E6C8",
  "cameobellini": "#F1E6C8",
  "plainbellini": "#F1E6C8",
  "bois": "#F1E6C8",
  "piedbois": "#F1E6C8",
  "beigechine": "#e7d7cc",
  "navy/beige": "#F1E6C8",
  "grey": "#a5a4a6",
  "coldgrey": "#a5a4a6",
  "darkgrey": "#6c6b6e",
  "plaquéor": "#FFD700",
  "greenleaves": "#811453",
  "Greenleaves": "#811453",
  "acierinoxidableor": "#FFD700",
  "acierinoxidabledoré": "#FFD700",
  "acierinoxor": "#FFD700",
  "multicolore": "#F1E6C8",
  "muscade": "#c45e47",
  "blanche": "#F5F5F5",
  "lecce": "#F5F5F5",
  "rayébleuetblanc": "#F5F5F5",
  "bicolor": "#F5F5F5",
  "plainwhite": "#F5F5F5",
  "craie": "#F5F5F5",
  "blanc/rose": "#F5F5F5",
  "blanc/noir": "#F5F5F5",
  "tricoloreblanc": "#F5F5F5",
  "alu": "#369c90",
  "blanc-3001": "#F5F5F5",
  "blanc-6001": "#F5F5F5",
  "blanccasse": "#F5F5E9",
  "ficelle": "#F5F5E9",
  "bleuazur": "#1B72C7",
  "bleulagon": "#72b5a8",
  "nuage": "#c4b5b9",
  "bleubleuet": "#4374C3",
  "bubblechine": "#f095bf",
  "bleuprovence": "#4374C3",
  "bleuocean": "#4374C3",
  "bleucerule": "#95ABC",
  "bleuciel": "#9EC3E0",
  "rayuresbleues": "#9EC3E0",
  "vichy": "#9EC3E0",
  "Athènes": "#9EC3E0",
  "bleuoxford": "#9EC3E0",
  "vichybleu": "#9EC3E0",
  "bleuvintage": "#9EC3E0",
  "bleuchiné": "#9EC3E0",
  "suedeciel": "#9EC3E0",
  "bleuciel/blanc": "#9EC3E0",
  "bardogalaxy": "#9EC3E0",
  "ciel": "#9EC3E0",
  "bleufumee": "#C5D8DF",
  "bleugris": "#798A94",
  "bleufumé": "#798A94",
  "bleucendre": "#798A94",
  "bleuglacier": "#798A94",
  "bleu-64": "#40ffec",
  "bleu-35": "#164bde",
  "bleugrisé": "#798A94",
  "bleumarine": "#03224C",
  "bleumer": "#03224C",
  "imprimécarreaux": "#03224C",
  "nylonbleu": "#03224C",
  "bleu/rouge/noir": "#03224C",
  "bleu/rose": "#03224C",
  "bleu/moutarde": "#03224C",
  "bleu/terracotta": "#03224C",
  "bleuliégé": "#03224C",
  "bleudenimliégé": "#03224C",
  "black/blue": "#C5D8DF",
  "multicoloremarine": "#03224C",
  "bicolorerose": "#ed5571",
  "bicolore": "#1d2024",
  "kakimoyen": "#766722",
  "bleunuit": "#1537A5",
  "lapislazuli": "#26619c",
  "lapislazuli/gold": "#26619c",
  "lapislazuli/silver": "#26619c",
  "universe": "#1537A5",
  "klein": "#002FA7",
  "electrique": "#002FA7",
  "nocturne": "#1537A5",
  "bordeau": "#861E15",
  "grege": "#C0B8A5",
  "grisacier": "#ACACAC",
  "grisfume": "#949494",
  "grèggrainé": "#949494",
  "gardenecru": "#e3e4e6",
  "janisecru": "#d94f36",
  "fleursecru": "#086636",
  "maillonabricot": "#f0d7af",
  "rouille": "#de6b54",
  "suederouille": "#de6b54",
  "lilasdeperse": "#de6b54",
  "navy/rouille": "#de6b54",
  "printpois": "#2e2d2d",
  "printfloral": "#5e90ab",
  "grisanthracite": "#1F1F1F",
  "grisdelin": "#E1CEE1",
  "grisfer": "#525252",
  "twigabanana": "#4A8D4B",
  "twigapagode": "#A92424",
  "bellmazarine": "#063559",
  "bellnirvana": "#2F2D9C",
  "sagarpersian": "#5674BC",
  "grispave": "#707070",
  "mixiconsantinigalaxy": "#A3D0F4",
  "plainpagode": "#233F23",
  "grisperle": "#C8C8C8",
  "grissouris": "#909090",
  "palmlavenderlime": "#2B9F69",
  "grisfoncé": "#808080",
  "palmcascadelavender": "#8E9FCA",
  "lavende": "#9683ec",
  "havane": "#55462C",
  "jaunebanane": "#978611",
  "myrtabanana": "#FFDE59",
  "wavymazarine": "#978611",
  "orchidjade": "#4C8336",
  "plainrio": "#BD3450",
  "wavybanana": "#978611",
  "noribanana": "#1F8A87",
  "jaunecanari": "#DFE219",
  "bloommandarin": "#1A8537",
  "jaunecitron": "#FEF720",
  "talacitrus": "#FEF720",
  "citrus": "#FEF720",
  "jaunedemars": "#FBC741",
  "jaune": "#FEDF4B",
  "Camo": "#FEDF4B",
  "jaune-2packs": "#FEDF4B",
  "mixnorimazarine": "#FEDF4B",
  "borapagode": "#FEDF4B",
  "plainbeeswax": "#FEDF4B",
  "twiggypersian": "#FEDF4B",
  "jaune-bleu": "#FEDF4B",
  "jaune/ecru": "#FEDF4B",
  "jaune/blanc": "#FEDF4B",
  "jaune/bleu": "#FEDF4B",
  "kaki": "#625510",
  "kaki/jaune": "#625510",
  "vertkaki": "#625510",
  "eucalyptus": "#625510",
  "lurexvert/gris": "#889492",
  "orage": "#64718f",
  "fleurs": "#39a3db",
  "mouchete": "#f5b6a2",
  "hollyhock": "#af36e3",
  "hibiscus": "#e85dd1",
  "bouteille": "#444f43",
  "mosaicblue": "#5183bd",
  "bleupetrole": "#6a7e85",
  "poppyred": "#f21f31",
  "jaunefressia": "#f1f73e",
  "magentafonce": "#44215E",
  "magentafushia": "#EA406D",
  "fucshia": "#EA406D",
  "marron": "#4D2E0F",
  "princesdegalles": "#4D2E0F",
  "cuirrouille": "#4D2E0F",
  "twigabellini": "#4D2E0F",
  "boramuscade": "#4D2E0F",
  "plainbreen": "#4D2E0F",
  "tiedyemuscade": "#4D2E0F",
  "steppebellini": "#4D2E0F",
  "mxbreen": "#4D2E0F",
  "dropmist": "#4D2E0F",
  "plainclove": "#4D2E0F",
  "marron-jaune": "#4D2E0F",
  "borabreen": "#80471C",
  "ringbreen": "#795C34",
  "siennegrainé": "#4D2E0F",
  "charme/multico": "#4D2E0F",
  "marshmallow/multico": "#fafae8",
  "marshmallow/smoking": "#fcfcfa",
  "marshmallow/copper": "#fcfcfa",
  "coquille": "#f0eee6",
  "fleur": "#f8d4fa",
  "toudou": "#8db9cc",
  "vino/marshmallow": "#ad917f",
  "fontaine": "#7dbfdb",
  "fontaine/marshmallow": "#7dbfdb",
  "rosako/marshmallow": "#edc8c2",
  "rosako/copper": "#edc8c2",
  "rosako": "#edc8c2",
  "marshmallow": "#f0f0e4",
  "marronfonce": "#633b0e",
  "marron/navy": "#4D2E0F",
  "cigare": "#4D2E0F",
  "moutarde": "#B49B17",
  "verde": "#0b998b",
  "petunia": "#cc45a4",
  "fusion": "#e3c22d",
  "noir-in-nude": "#000000",
  "suedenoir": "#000000",
  "noirsetaria": "#000000",
  "noirrayesatine": "#000000",
  "noirraye": "#000000",
  "tourmalinenoire/gold": "#000000",
  "tourmalinenoire/silver": "#000000",
  "laiton": "#000000",
  "noirgrainé": "#32262b",
  "noir / dore": "#000000",
  "noir/vert": "#000000",
  "noir/bordeaux": "#000000",
  "vienne": "#fad2fa",
  "vienne/ecume": "#fad2fa",
  "vienne/cupcake": "#fad2fa",
  "cuivre/capecod": "#d6a85e",
  "fraicheur/ecume": "#50a9f2",
  "fraicheur": "#50a9f2",
  "belugachine": "#9fa4b3",
  "perse": "#3457bf",
  "noir/ecru": "#000000",
  "noir/bleu": "#000000",
  "gris-2packs": "#d4d4d4",
  "iconpagode": "#377D6F",
  "pankafrostygreen": "#d4d4d4",
  "sagarfrostygreen": "#d4d4d4",
  "grisclair": "#e6e6e6",
  "grisvintage": "#e6e6e6",
  "mixkirefasayfrostygreen": "#e6e6e6",
  "plainfrostygreen": "#e6e6e6",
  "grismoyen": "#9e9ea3",
  "cameomist": "#61C2D1",
  "gris/ocre": "#d4d4d4",
  "gris/kaki": "#d4d4d4",
  "gris/noir": "#d4d4d4",
  "noir/gris": "#d4d4d4",
  "noir-bleu": "#000000",
  "kaki/gris": "#d4d4d4",
  "noir-3280": "#000000",
  "noir-5280": "#000000",
  "noir-6280": "#000000",
  "black/black": "#000000",
  "granadablack": "#bb0b0b",
  "black/green": "#000000",
  "darknavy": "#090b30",
  "black/kakipiping": "#030303",
  "navypiping": "#0c0a38",
  "navy/bronze": "#110e4a",
  "navy/orange": "#110e4a",
  "whitepiping": "#fcfafa",
  "plainlychee": "#D13216",
  "fasaykirepersian": "#774AB4",
  "mandalawilow": "#2F8F3F",
  "ringacai": "#B35CB8",
  "paisleyprint": "#F9AE29",
  "vert/ocre": "#F9AE29",
  "ecru/terrebrulee": "#F9AE29",
  "tabac": "#9c750b",
  "ocre/chocolat": "#F9AE29",
  "ocre/rouge": "#F9AE29",
  "chocolat": "#554947",
  "suedechoco": "#554947",
  "chocolat/gold": "#75605a",
  "ecruocre": "#F9AE29",
  "lurexocre": "#F9AE29",
  "darkkaki": "#424743",
  "kakifonce": "#424743",
  "kakichine": "#4b5143",
  "plainaperol": "#F2622D",
  "plainspice": "#F2622D",
  "caprioaperol": "#F2622D",
  "faraclove": "#F2622D",
  "twiggybeeswax": "#F2622D",
  "persan": "#213656",
  "seigle": "#d7b689",
  "tournesol": "#f9c22d",
  "violeta": "#a274a6",
  "plainacai": "#a274a6",
  "whitechine": "#e7e7e7",
  "sylvestre": "#636d65",
  "marmelade": "#ca5c4b",
  "multicoorange": "#F2622D",
  "cumin": "#F2622D",
  "flamingo": "#f58258",
  "sunflower": "#f2c329",
  "lila": "#fce1f6",
  "mineral": "#a2baa5",
  "jaunekaki": "#B7C4B8",
  "bleupale": "#dceefa",
  "monstera": "#6093AC",
  "bleuchine": "#5E92DC",
  "fdblack": "#3a3a3b",
  "dnmv-60": "#6888a3",
  "dnmv-70": "#81a6c7",
  "dnmb-20": "#375d87",
  "dnmm-89": "#d3e2f2",
  "dnmv-62": "#5780ad",
  "denimwhite": "#ffffff",
  "denimm-51": "#53628c",
  "mossgrey": "#c7cad4",
  "silverblue": "#c1c8e0",
  "glacier": "#e3faf7",
  "vintagekaki": "#969687",
  "orangecitrouille": "#F4792C",
  "orange/noir": "#F4792C",
  "parme": "#966DAF",
  "lagon": "#36a4a8",
  "lagonclair": "#36a4a8",
  "lagon-ivoire-verteco": "#36a4a8",
  "peche": "#D27647",
  "rainbow": "#E5D5C3",
  "pomme": "#E5D5C3",
  "gun": "#525252",
  "ponceau": "#B12A1F",
  "pourpre": "#75191E",
  "indiana": "#067790",
  "northsea": "#067790",
  "rose": "#F26CAE",
  "babyrose": "#F26CAE",
  "lesroses": "#F26CAE",
  "rose/jaune": "#F26CAE",
  "mixiconcamelia": "#F26CAE",
  "ikalahotpink": "#F26CAE",
  "capriohotpink": "#F26CAE",
  "donaacai": "#F26CAE",
  "plainpink": "#F26CAE",
  "rose/pourpre/marron": "#F26CAE",
  "canyon": "#FDB0AA",
  "peoniespapayaatlantis": "#AABADE",
  "joli": "#f7c6cb",
  "mandalalavenderwhite": "#6891EB",
  "joli/dore": "#f7c6cb",
  "speciallot00": "#f7cbf3",
  "speciallot99": "#ba0725",
  "rose/navy": "#F26CAE",
  "santinigalaxy": "#8DA5ED",
  "rosee": "#d9bdc2",
  "plaincamelia": "#E97AAF",
  "wavycamelia": "#C4363E",
  "borabellini": "#9DC2C3",
  "iconbardogalaxy": "#8D9ED9",
  "plainjade": "#5D8640",
  "tropicana": "#d7a1b1",
  "navy/rouge": "#d9bdc2",
  "moussederougedaphné": "#b23f44",
  "moussederougegarance": "#b54142",
  "moussederougepivoine": "#cd534e",
  "moussederougeframboise": "#6f1636",
  "moussederougecamélia": "#a1484e",
  "moussederougedahlia": "#941f2f",
  "rouge/marine": "#f2132a",
  "rosevif": "#F26CAE",
  "cocogalaxy": "#7CA8D9",
  "aloha": "#F26CAE",
  "rosevert": "#F26CAE",
  "rosebonbon": "#F1508D",
  "bonbon": "#7d172d",
  "daphné": "#db4659",
  "rosedragee": "#F3C0CF",
  "rosefushia": "#E14285",
  "rosebain": "#E14285",
  "greige": "#fce5cd",
  "rosepale": "#F7D7D8",
  "grapefruit": "#F7D7D8",
  "rouge": "#EF3C2E",
  "lesrouges": "#EF3C2E",
  "rouge-2packs": "#EF3C2E",
  "rouge/jaune": "#EF3C2E",
  "mixnoricamelia": "#EF3C2E",
  "cameoaruba": "#EF3C2E",
  "orchidlychee": "#EF3C2E",
  "boracamelia": "#EF3C2E",
  "bardolychee": "#EF3C2E",
  "santinilychee": "#EF3C2E",
  "myrtalychee": "#EF3C2E",
  "dropnirvana": "#EF3C2E",
  "mixsantinilychee": "#EF3C2E",
  "rajaprint": "#EF3C2E",
  "cameomimosa": "#35569D",
  "rouge/khaki": "#EF3C2E",
  "rougebleu": "#EF3C2E",
  "tricolorerouge": "#EF3C2E",
  "goji": "#EF3C2E",
  "chili": "#EF3C2E",
  "groseiller": "#e3547a",
  "groseille": "#cf0a1d",
  "santinijade": "#4CC671",
  "groseiller/crystal": "#e3547a",
  "lurex": "#cfd4d3",
  "rougecardinal": "#E2392B",
  "rougecerise": "#BF2E22",
  "myrtacamelia": "#BF2E22",
  "sable": "#E4DCC9",
  "plaindesert": "#E4DCC9",
  "tangerine": "#DF4929",
  "taupe": "#837363",
  "taupe/blanc": "#837363",
  "suedetaupe": "#837363",
  "vertlime": "#8BD600",
  "vertfluo": "#83f52c",
  "mousse-ivoire-champagne": "#83f52c",
  "plainprairie": "#83f52c",
  "orangefluo": "#F2622D",
  "sagaraperol": "#F2622D",
  "vertturquoise": "#ACE8E3",
  "turquoiseafricaine": "#ACE8E3",
  "vertpale": "#F0FFF0",
  "vertmalachite": "#096a09",
  "Vertetlavande": "#419F32",
  "vert-2packs": "#419F32",
  "cuirvert": "#419F32",
  "brioche": "#5f2428",
  "chouquette": "#7d3a32",
  "cuirocéan":"#1c2842",
  "peche-vert": "#419F32",
  "vert/violet": "#419F32",
  "vert/rose": "#419F32",
  "vert/gris": "#758063",
  "palmlimelavender": "#7AD4C4",
  "ecru/vert": "#419F32",
  "carreauxvert": "#419F32",
  "carreauxbleu": "#4aace8",
  "carreauxrouge": "#f72354",
  "vertsafari": "#33695a",
  "vertolive": "#558E0E",
  "vertprairie": "#59BF1E",
  "vertsapin": "#1E4728",
  "vertfoncé": "#006400",
  "vertforêt-fusil-gris": "#006400",
  "palmlimepapaya": "#006400",
  "mixprintpagode": "#006400",
  "violet": "#592B87",
  "figpurple": "#592B87",
  "naturalpeony": "#592B87",
  "pansy": "#592B87",
  "Muse": "#592B87",
  "ikalapersian": "#592B87",
  "fasayskyway": "#592B87",
  "plainmazarine": "#647ECE",
  "farapersian": "#592B87",
  "plainpersian": "#592B87",
  "violet-turquoise": "#592B87",
  "vert-violet": "#592B87",
  "violine": "#592B87",
  "violet/jaune": "#592B87",
  "pinede": "#3a5d70",
  "acier": "#AFAFAF",
  "argent": "#cfcfcf",
  "maillemilanaiseacier": "#cfcfcf",
  "maillemilanaise": "#cfcfcf",
  "maillemilanaisedorérose": "#e7b2a4",
  "argent925": "#cfcfcf",
  "acierinoxydableargenté": "#cfcfcf",
  "acierinoxargent": "#cfcfcf",
  "acierinoxidableargent": "#cfcfcf",
  "acierinoxidableargenté": "#cfcfcf",
  "argenté": "#cfcfcf",
  "argent/gold": "#cfcfcf",
  "platinium": "#cfcfcf",
  "beigefonce": "#C8AD7F",
  "beigeclair": "#ede8df",
  "Confettis": "#ede8df",
  "bronze": "#D5BD66",
  "celadon": "#93bfc4",
  "camel": "#BF8A3D",
  "camel/camel": "#BF8A3D",
  "camel/rouge": "#BF8A3D",
  "suedecamel": "#BF8A3D",
  "icymint": "#9ff5f3",
  "smokypink": "#fceae3",
  "sunshine": "#fafcc2",
  "nauticalblue": "#3842f5",
  "oldrose": "#e3c1b3",
  "rosefoncé": "#e3c1b3",
  "rose-lézard": "#e3c1b3",
  "pinkleaves": "#e3c1b3",
  "cognac": "#BB6144",
  "goldantic": "#BB6144",
  "orantic": "#BB6144",
  "cognac-lézard": "#BB6144",
  "corail": "#E73E01",
  "impriméfleuri": "#FF7F50",
  "turquoisecorail": "#E73E01",
  "cuivre": "#B36700",
  "Acierinoxydabledoré": "#EFD807",
  "dore": "#EFD807",
  "doré": "#EFD807",
  "ecru": "#FEFEE0",
  "veloursecru": "#FEFEE0",
  "ecrucroco": "#FEFEE0",
  "ecru/bordeaux": "#FEFEE0",
  "ecru/noir": "#FEFEE0",
  "noir-ecru-nude": "#FEFEE0",
  "violetclair": "#ce8dfc",
  "absinthe": "#cfcc78",
  "creme": "#FEFEE0",
  "raye": "#FEFEE0",
  "creamwhite": "#FEFEE0",
  "crème": "#FEFEE0",
  "fuschia": "#FD3F92",
  "cactusflower": "#FD3F92",
  "nude": "#FBC398",
  "lesnudes": "#FBC398",
  "or": "#EFD807",
  "ormat": "#EFD807",
  "rose-16": "#fad4f4",
  "rose-49": "#cf36ab",
  "vert-09": "#abf5af",
  "vert-18": "#07780d",
  "bleuclair": "#dcf4f7",
  "denimclair": "#dcf4f7",
  "rainbowmazarine": "#dcf4f7",
  "palmcascadewhite": "#dcf4f7",
  "bleuroi": "#318ce7",
  "mixmyrtamazarine": "#318ce7",
  "poisecru": "#d9d8d0",
  "chamallow": "#d9d8d0",
  "topaze": "#4597a1",
  "silvergold": "#EFD807",
  "orpale": "#EFD807",
  "platine": "#7F7679",
  "bleu-2packs": "#195ABC",
  "bleuvert": "#195ABC",
  "suedebleu": "#195ABC",
  "myrtaatoll": "#195ABC",
  "mixfasayskyway": "#195ABC",
  "bleu-rouge": "#195ABC",
  "bleu/brique": "#195ABC",
  "bleu/blanc": "#195ABC",
  "bleu/rouge": "#195ABC",
  "bleu/khaki": "#195ABC",
  "jauneetvert": "#FDAC00",
  "jauneetvert-2packs": "#FDAC00",
  "dnmb-23": "#5f7fb3",
  "dnmb-28": "#d2e1fa",
  "cream": "#f7e9be",
  "pankaskyway": "#A482C0",
  "rougeetjaune": "#E40917",
  "rougeetjaune-2packs": "#E40917",
  "rougeetbleu-2packs": "#E40917",
  "rougeetbleu": "#E40917",
  "bleuetvert": "#143360",
  "bleuetvert-2packs": "#143360",
  "assorted2": "#f032d6",
  "multico": "#f7d0ef",
  "multicouleur": "#7CC4BC",
  "multicolor": "#f7d0ef",
  "vertjade": "#d7f5e4",
  "royal": "#195ABC",
  "steelblue": "#4682B4",
  "amaranthred": "#E52B50",
  "darktaupe": "#483C32",
  "pearlgrey": "#737C7E",
  "pinkgold": "#B76E79",
  "darkbronze": "#804a00",
  "grenat": "#6e0b14",
  "dune": "#e2d1b8",
  "gazon": "#3a9d23",
  "grappe": "#861E15",
  "dragee": "#F3C0CF",
  "menthe": "#b0f2b6",
  "noisettine": "#955628",
  "nectarine": "#bf855b",
  "steppenectar": "#bf855b",
  "mixprintnectar": "#bf855b",
  "dropnectar": "#bf855b",
  "grisperlechine": "#C8C8C8",
  "cuirgris": "#C8C8C8",
  "azur": "#1B72C7",
  "blondiechine": "#978611",
  "fraise": "#bf3030",
  "zac": "#000000",
  "violaine": "#F1E6C8",
  "aquarium": "#4374C3",
  "ambre": "#edc328",
  "orient": "#DF6D14",
  "diva": "#FBF2B7",
  "doucette": "#FFE8D6",
  "noisetier": "#955628",
  "calissonchine": "#FEDF4B",
  "aurore": "#f0e918",
  "aqua": "#c6f0f5",
  "apatiteaqua": "#c6f0f5",
  "nuit": "#1b203a",
  "girly": "#F26CAE",
  "loupchine": "#C8C8C8",
  "foin": "#E4DCC9",
  "flamantrose": "#F59DB2",
  "flamant": "#F59DB2",
  "flamand": "#F59DB2",
  "rosefoncé-rose-rouge": "#F59DB2",
  "limonade": "#FEF720",
  "jusdorange": "#F2622D",
  "twiggyfrostygreen": "#FA8128",
  "paturage": "#3a9d23",
  "flamenco": "#EF3C2E",
  "faon": "#8a4000",
  "cosmos": "#3b5b7b",
  "firework": "#1F1F1F",
  "marronrouge": "#EF3C2E",
  "havana/brown": "#EF3C2E",
  "napperon": "#F4792C",
  "caraibe": "#F5F5F5",
  "bleachblue": "#C5D8DF",
  "bleach": "#C5D8DF",
  "chantilly": "#F5F5E9",
  "pacifique": "#4374C3",
  "norimimosa": "#3833BD",
  "cameleon": "#978611",
  "plainregatta": "#28A78C",
  "flamme": "#DF4929",
  "cassonade": "#E4DCC9",
  "arome": "#8fbc8f ",
  "limoncello": "#FEDF4B",
  "carbone": "#222a32",
  "terre": "#945b4c ",
  "terredesienne": "#882D17 ",
  "mediterranee": "#146eb4",
  "petale": "#F7D7D8",
  "petal": "#e3b1b3",
  "mimi": "#7eb1c2",
  "golf": "#1E4728",
  "thym": "#667848 ",
  "framboise": "#F1508D",
  "papilioframboise": "#e62750",
  "papiliovert": "#22451c",
  "citrine": "#e0c206",
  "citrine/gold": "#e0c206",
  "citrine/silver": "#e0c206",
  "curcuma": "#e0c206",
  "citron": "#f5d405",
  "ikalacitrus": "#f5d405",
  "plaincitrus": "#f5d405",
  "rosenacree": "#F7D7D8",
  "thalasso": "#798A94",
  "sunrise": "#ff8e81",
  "grischine": "#C8C8C8",
  "grischiné": "#C8C8C8",
  "acidule": "#f2f289",
  "chataignier": "#a3541a",
  "baltique": "#9EC3E0",
  "fleurbleue": "#9EC3E0",
  "marta": "#785e2f",
  "matelasjaune": "#FEDF4B",
  "panther/brown": "#FEDF4B",
  "petitpois": "#265932",
  "cascade": "#9EC3E0",
  "baron": "#861E15",
  "tigre": "#F9AE29",
  "rosier": "#F3C0CF",
  "verveine": "#556b2f",
  "smoky": "#383e42",
  "marin": "#357ab7",
  "mojito": "#568652 ",
  "antilope": "#978611",
  "orchidee": "#fe7272",
  "plomb": "#263a4e",
  "mandarinier": "#ff6913",
  "glacon": "#ACACAC",
  "pharaon": "#d7b37d",
  "atlantide": "#03224C",
  "banane": "#ffff90",
  "steppebanana": "#ffff90",
  "miel": "#89743d",
  "opalerose": "#FEBFD2",
  "daim": "#ac5000",
  "nacre": "#F5F5F5",
  "nacrecreme": "#F5F5F5",
  "nacreblanc": "#F5F5F5",
  "blancnacre": "#F5F5F5",
  "nacreblanche": "#F5F5F5",
  "pierredelune": "#F5F5F5",
  "pierredelune/gold": "#F5F5F5",
  "pierredelune/silver": "#F5F5F5",
  "apatitebleue": "#4682B4",
  "alguemarine": "#ADD8E6",
  "nuageux": "#909090",
  "bambou": "#667848 ",
  "polaire": "#C8C8C8",
  "berlingot": "#F59DB2",
  "ivoire": "#F5F5E9",
  "ivoireliégé": "#F5F5E9",
  "vichyciel": "#b2ecfb",
  "cheesecake": "#F5F5E9",
  "roseraie": "#ff7f61",
  "carmin": "#960018",
  "carmincroco": "#960018",
  "perle": "#F5F5E9",
  "saumon": "#fb6356",
  "soja": "#cbcb66",
  "jungle": "#739185",
  "scarabee": "#24445c",
  "caraibes": "#579694",
  "safran": "#f6b256",
  "safranglacier": "#E1AF10",
  "basilic": "#457a45",
  "waves": "#45517a",
  "plainatoll": "#4285A7",
  "rosepoudre": "#FAD7DF",
  "blinis": "#FAD7DF",
  "kerangbreen": "#BEAE5D",
  "iconcamelia": "#D279A2",
  "coralgarden": "#FAD7DF",
  "rosepoudré": "#FAD7DF",
  "poudre": "#fce6eb",
  "chlorophyle": "#179683",
  "jaunepaille": "#eef0c0",
  "feather": "#ebeff0",
  "navydiamond": "#0d1438",
  "redleo": "#d6385d",
  "scaleblue": "#9ae5ed",
  "vanille": "#f4f49b",
  "painepice": "#dc901b",
  "vertamande": "#308f5a",
  "iconmist": "#D4F0F1",
  "fasaykireprairie": "#498AD0",
  "vertamandeliégé": "#308f5a",
  "embossélézardvertamande": "#308f5a",
  "vertdeau": "#c1ebd4",
  "plainkrinklearuba": "#c1ebd4",
  "jasperouge": "#B22222",
  "vertd'eau": "#c1ebd4",
  "vertd'eau/bordeaux": "#c1ebd4",
  "vertfleur": "#c1ebd4",
  "vertclair": "#45e660",
  "vertsauge": "#689d71",
  "mandalapapayaatlantis": "#ED776D",
  "melrosementhecitron": "#45e660",
  "vertfonce": "#566b55",
  "mandalalimelavender": "#566b55",
  "mandalacascadelavender": "#95A7E9",
  "jaspeverte": "#218E76",
  "jaspekiwi": "#BDDFE2",
  "rubischauffe": "#a31e50",
  "lepidolite": "#D7BDE2",
  "lepidoliteviolette": "#D7BDE2",
  "faience": "#c1ebd4",
  "snake": "#b6b428",
  "darkgold": "#daa520",
  "redsnake": "#861E15",
  "paprika": "#c71b0c",
  "gold": "#f2df7d",
  "noir/gold": "#f2df7d",
  "camel/leopard": "#e5cf8c",
  "carotte/fontaine": "#e68619",
  "black/zebrahairy": "#000000",
  "embossélézardnoir": "#000000",
  "silver": "#cfcfcf",
  "black/silver": "#cfcfcf",
  "pouderpink": "#F59DB2",
  "camel/beige": "#BF8A3D",
  "naturelcroco": "#BF8A3D",
  "toastedalmond": "#BF8A3D",
  "rayures": "#cf850e",
  "coquillage": "#f7e4c6",
  "seagreen/ocre": "#7fc9ad",
  "fushia": "#E14285",
  "suedefushia": "#E14285",
  "ikate": "#E14285",
  "ikat": "#E14285",
  "blush": "#f26369",
  "brique": "#f26369",
  "palmpapayaatlantis": "#f26369",
  "ecru/brique": "#f26369",
  "camel/gold": "#BF8A3D",
  "black/gold": "#000000",
  "cobrasilver": "#C0C0C0",
  "zebra/black": "#000000",
  "blackpython": "#b4b4b4",
  "cooper": "#e0b690",
  "pewter": "#828388",
  "leopard/black": "#e5cf8c",
  "tancroco": "#BF8A3D",
  "greencroco": "#1E4728",
  "black/leopard": "#e5cf8c",
  "blossom": "#f6bfc9",
  "darkgold/camel": "#c68856",
  "darkgold/white": "#F5F5F5",
  "silver/darkgold": "#f2df7d",
  "gold/rosegold/silver": "#000000",
  "gold/darkgold/cooper/rosegold": "#BF8A3D",
  "silver/black": "#cfcfcf",
  "blackbuff": "#000000",
  "coalblack": "#000000",
  "cypresgreen": "#000000",
  "blackmetalic": "#525252",
  "blackcherry": "#52253a",
  "darkgold/silver/rosegold": "#cfcfcf",
  "aqua/green/parrotgreen": "#69d2cf",
  "silver/gold": "#cfcfcf",
  "darkgold/black": "#f2df7d",
  "gold/leopard/black": "#e5cf8c",
  "silver/zebra/black": "#000000",
  "black/snake": "#525252",
  "redpython": "#861E15",
  "black/white": "#000000",
  "zebra": "#e5cf8c",
  "burgundy/camel": "#861E15",
  "black/alligator": "#525252",
  "grey/silver": "#cfcfcf",
  "black/zebre": "#e5cf8c",
  "camel/pinkgold": "#BF8A3D",
  "goldsnake": "#f2df7d",
  "white/silver/black": "#000000",
  "leopard/darkgold/camel/black": "#BF8A3D",
  "camel/leopard/python": "#BF8A3D",
  "navy/electricblue/turquoise/silver": "#69d2cf",
  "black/grey/leopard/python": "#000000",
  "silversnake": "#C0C0C0",
  "silver/black/pewter": "#000000",
  "navy/silver/gold": "#4682B4",
  "gold/camel/ivory": "#BF8A3D",
  "leopard": "#e5cf8c",
  "python": "#b4b4b4",
  "camel/tigre": "#BF8A3D",
  "red/gold": "#EF3C2E",
  "grey/snake": "#C0C0C0",
  "lightgold": "#f6f0d3",
  "black/silver/black": "#000000",
  "navy/silver": "#03224C",
  "bordeaux/navy": "#313740",
  "agateverte": "#307026",
  "tea": "#307026",
  "agatenoire": "#000000",
  "noirardoise": "#000000",
  "nylonnoir": "#000000",
  "onyxnoire": "#000000",
  "agatebleu": "#191287",
  "agatebleue": "#191287",
  "agategrise": "#51515c",
  "pyrite/gold": "#51515c",
  "pyrite": "#51515c",
  "pyrite/silver": "#51515c",
  "cornaline": "#b8473b",
  "cornalinerouge": "#b8473b",
  "blackspinelle": "#000000",
  "multiquartz": "#1B72C7",
  "tourmalinerose": "#d16ea0",
  "suedemarine": "#021836",
  "bleuminuit": "#021836",
  "bleuturquoise": "#2084a8",
  "atlantique": "#2F8F98",
  "tomette": "#d46661",
  "charcoal": "#242222",
  "charcoalchecks": "#242222",
  "soleil": "#f5f536",
  "ocean": "#3684bf",
  "agrume": "#eb660e",
  "terra": "#bd7f4f",
  "bronzedore": "#614E1A",
  "noir/bronze": "#614E1A",
  "kaki/bronze": "#614E1A",
  "taupedore": "#837363",
  "grisfonce": "#606060",
  "farafrostygreen": "#606060",
  "oeil-de-tigre": "#7f4d0e",
  "amazonite": "#3be7d7",
  "amazonite/gold": "#3be7d7",
  "amazonite/silver": "#3be7d7",
  "ballerine": "#f7d1b7",
  "grenadine": "#f50f35",
  "caprioimperial": "#06c6ff",
  "pankaimperial": "#06c6ff",
  "jaspeturquoise": "#06c6ff",
  "turquinite": "#06c6ff",
  "turquoise/camel": "#06c6ff",
  "turquoise/violet": "#06c6ff",
  "apatiteturquoise": "#06c6ff",
  "calcedoinepink": "#f1508d",
  "quartzrubis": "#ad2156",
  "quartzrose": "#f79abd",
  "quartzrose/gold": "#f79abd",
  "quartzrose/silver": "#f79abd",
  "blackonyx": "#000000",
  "quartzsaphir": "#195abc",
  "labradorite": "#C8C8C8",
  "labradorite/gold": "#C8C8C8",
  "labradorite/silver": "#C8C8C8",
  "agateblanche": "#F5F5F5",
  "treflerouge": "#EF3C2E",
  "luckrouge": "#EF3C2E",
  "treflebleu": "#195abc",
  "luckbleu": "#195abc",
  "bleurose": "#F5E6F3",
  "lucknoir": "#000000",
  "calcedoinerosevif": "#f1508d",
  "calcedoinerose": "#f79abd",
  "calcédoinerose": "#f79abd",
  "calcedoinebleue": "#5077b6",
  "calcédoinebleue": "#5077b6",
  "calcédoineverte": "#84ab7e",
  "iolite": "#3370d3",
  "calcedoinepeche": "#7f4d0e",
  "calcédoinepeche": "#c96614",
  "calcedoinecorail": "#ec3652",
  "calcedoineemeraude": "#7a8a54",
  "quartzemeraude": "#7a8a54",
  "emeraude": "#7a8a54",
  "crystal": "#e9f0f2",
  "cristal": "#e9f0f2",
  "cristalderoche/gold": "#e9f0f2",
  "cristalderoche/silver": "#e9f0f2",
  "corailrose": "#f79abd",
  "montana": "#195abc",
  "emerald": "#419F32",
  "malachitevert": "#096a09",
  "lapis": "#195abc",
  "quartzblanc": "#fcfcfc",
  "aventurine": "#68c38e",
  "rhodocrosite": "#f79abd",
  "pacific": "#78948f",
  "pacificopal": "#78948f",
  "burgundy": "#861E15",
  "calcedoineblanche": "#F5F5F5",
  "calcédoineblanche": "#F5F5F5",
  "onyxnoir": "#000000",
  "onyxvert": "#98ba97",
  "multistone": "#f79abd",
  "onyx": "#000000",
  "blackdiamond": "#000000",
  "golden": "#EFD807",
  "coquelicot": "#c60800",
  "anis": "#fff38b",
  "blanc/rouge": "#EF3C2E",
  "jade": "#00866e",
  "multico/orange": "#F2622D",
  "multico/foret": "#1E4728",
  "chair": "#FEC3AC",
  "litchi": "#feab8b",
  "noir/marine": "#03224C",
  "multico/pasteque": "#EF3C2E",
  "multicodenim": "#4374C3",
  "horizon": "#c4d0d8",
  "multico/jaune": "#FEDF4B",
  "abricot": "#fabea2",
  "betina": "#F5F5F5",
  "bird": "#f4a819",
  "blue": "#195ABC",
  "mauvefoncé": "#590716",
  "câblebordeaux": "#590716",
  "mixsteppepagode": "#590716",
  "steppepagode": "#590716",
  "pack3": "#861E15",
  "vert/noir/bleunuit": "#2a753e",
  "bordeaux/orange": "#861E15",
  "brun": "#904D0A",
  "brunfonce": "#5b3c11",
  "terrebattue": "#bf6d1b",
  "brut": "#355975",
  "canard": "#048b9a",
  "petrol": "#01717F",
  "cuircanard": "#048b9a",
  "méditerranée": "#048b9a",
  "carreaux": "#F5F5F5",
  "cerise": "#99324e",
  "champagne": "#c3aa8f",
  "champagnemat": "#c3aa8f",
  "champagnesatine": "#c3aa8f",
  "clementine": "#eb5e00",
  "clementinefonce": "#9d0f00",
  "dehli": "#F5F5F5",
  "dotty": "#0e4bef",
  "ecru/carmin": "#960018",
  "ecru/flamingo": "#d67c99",
  "ecru/marine": "#03224C",
  "ecru/moutarde": "#B49B17",
  "ecru/poudre": "#F59DB2",
  "ecru/rouge": "#EF3C2E",
  "encre": "#0c1a66",
  "flore": "#f5d2da",
  "fraise/ecru": "#FEFEE0",
  "fraise/rose": "#fd6c9e",
  "glaçon": "#ACACAC",
  "griotte": "#b25f44",
  "guimauve": "#f3ebee",
  "india": "#a44414",
  "indiablue": "#c69294",
  "nusapenida": "#c69294",
  "indigo": "#1c1154",
  "indigochecks": "#1c1154",
  "indigotouareg": "#1c1154",
  "camomille": "#f0c189",
  "vraibeige": "#b3a28f",
  "costaapia": "#93a9bf",
  "junglador": "#9c9480",
  "kaolinos": "#e4d3e6",
  "lumapur": "#f5d451",
  "cobalto": "#20b2e3",
  "violetprofond": "#a13cc9",
  "persimon": "#ffa07a",
  "ardoise": "#4d7994",
  "jaipur": "#e392a1",
  "jasmin": "#e1d8c9",
  "jean": "#7b90a4",
  "kyoto": "#d34236",
  "lavande": "#e0c8da",
  "bleuette": "#e0c8da",
  "ludiana": "#F5F5F5",
  "mais": "#fcec34",
  "mandarine": "#ef702b",
  "marine/blanc": "#191c4a",
  "bleumarine/orange": "#191c4a",
  "bleumarine/camel": "#191c4a",
  "moutarde/blanc": "#dea92f",
  "moutarde/terracotta/rouge": "#dea92f",
  "moutarde/noir/terracotta": "#dea92f",
  "marine/ecru": "#FEFEE0",
  "mekiro": "#007fff",
  "seventies": "#f2bef7",
  "mimosa": "#ffca4b",
  "cocotiers": "#839c8e",
  "denim": "#5b79a3",
  "denimstone": "#5b79a3",
  "bleunavy": "#5b79a3",
  "minuit": "#0f388a",
  "monkey": "#63584c",
  "moony": "#61878b",
  "mouettes": "#b3a89b",
  "myrtille": "#1e1b54",
  "neela": "#d4e7ff",
  "neroli": "#ffd7a2",
  "okinawa": "#3d5a83",
  "opaline": "#c1d1c4",
  "palladio": "#f7a986",
  "pamplemousse": "#d45b63",
  "papaye": "#fdb065",
  "petitbrun": "#5b3c11",
  "pivoines": "#d993b1",
  "pois": "#d5ece0",
  "portobello": "#7d7061",
  "portofino": "#7b8eb8",
  "positano": "#74c2cc",
  "poudre/praline": "#e9ba95",
  "raphia": "#deb48b",
  "clémentine": "#f5a147",
  "rosechine": "#d993b1",
  "smoking": "#312f4d",
  "smoking/copper": "#312f4d",
  "smoking/dore": "#312f4d",
  "smoking/lait": "#312f4d",
  "smoking/marshmallow": "#312f4d",
  "smoking/terkuit": "#312f4d",
  "subway/boudor": "#b1b4b5",
  "shiva": "#a85443",
  "donacoconutmartini": "#7F8D34",
  "terkuit": "#c91c39",
  "terkuit/beluga": "#c91c39",
  "terkuit/marshmallow": "#c91c39",
  "lait": "#edecdf",
  "collinsdesert": "#DFF95E",
  "boudor": "#ebc623",
  "mixkirefasaybeeswax": "#A8701C",
  "boudor/city": "#ebc623",
  "bamboo": "#ebdd78",
  "bamboo/marshmallow": "#ebdd78",
  "riyadh": "#345cc9",
  "turquin/marshmallow": "#5e78bf",
  "cheek/marshmallow": "#dba7cc",
  "shitake/marshmallow": "#b0a289",
  "babylone/marshmallow": "#facff6",
  "shitake/or": "#b0a289",
  "babylone/argent": "#facff6",
  "maki/argent": "#878783",
  "shine/marshmallow": "#f1f745",
  "terracota": "#e2725b ",
  "terre-cuite": "#e2725b",
  "cuirterracotta": "#e2725b",
  "cuirpaon": "#067790",
  "donaspicesky": "#e2725b ",
  "donaspicecoconut": "#e2725b ",
  "the": "#662d33",
  "thé": "#662d33",
  "signal": "#d14a1d",
  "tilleul": "#98A473",
  "vert/bleu": "#20B2AA",
  "palmaprint": "#4ea4be",
  "violette": "#592B87",
  "voldenuit": "#98a1b4",
  "yogi": "#8a8b67",
  "yuzu": "#e5c78e",
  "acajou": "#88421d",
  "beigepoudre": "#F1E6C8",
  "beige/camel": "#BF8A3D",
  "suedecamelfonce": "#BF8A3D",
  "beige/noir": "#000000",
  "beige/or": "#EFD807",
  "beigerosé": "#ebc8b2",
  "jeans": "#3b72a2",
  "blancananas": "#ffcb00",
  "bleucanard": "#048b9a",
  "bleujoli": "#048b9a",
  "ringkiwi": "#195ABC",
  "bleufonce": "#00008B",
  "Océan": "#00008B",
  "bleumediterranee": "#00008B",
  "bleumediterraneesatine": "#00008B",
  "bleucroco": "#00008B",
  "mixnorimimosa": "#00008B",
  "bleuvif": "#00008B",
  "bleufonce/noir": "#00008B",
  "bleufume": "#C5D8DF",
  "waterfallblue": "#C5D8DF",
  "bleunuage": "#87CEEB",
  "seaspray": "#87CEEB",
  "bleuviolet": "#412ed6",
  "charbon": "#463b34",
  "desertcharbon/b": "#463b34",
  "desertorange/noir": "#ed8e4a",
  "floraljungle": "#766722",
  "foretverte": "#315D49",
  "Vertes": "#315D49",
  "bourgogne": "#66122b",
  "nordique": "#72a9ed",
  "pivoine": "#f283af",
  "galaxie": "#0b3661",
  "framboisenoire": "#F1508D",
  "framboise/noir": "#F1508D",
  "boisrose": "#c18e99",
  "darkrubis": "#46181b",
  "caramelchine": "#a87c5f",
  "hibiscuscoral": "#E73E01",
  "jardinsauvage": "#ffff7c",
  "jauneclair": "#ffff7c",
  "jauneclair/beige": "#ffff7c",
  "jaune-jardin-sauvage": "#ffff7c",
  "kaki/noir": "#625510",
  "kaki/marron": "#624c10",
  "orangesanguine": "#fa5e43",
  "sunset": "#FFB278",
  "noir-jardin-sauvage": "#000000",
  "prune/noir": "#2B2045",
  "rayon-de-soleil": "#ffff40",
  "roseclair": "#F3C0CF",
  "rose/blanc": "#F3C0CF",
  "rosevintage": "#F3C0CF",
  "opalrose": "#F3C0CF",
  "roseorangé": "#ff5e4d",
  "rougebrillant": "#EF3C2E",
  "rougebrillant/bleuviolet": "#EF3C2E",
  "rougecarmin": "#960018",
  "rougecoquelicot": "#c60800",
  "ecrevisse": "#c60800",
  "sangue": "#c60800",
  "rouge-orange": "#FF4500",
  "sablepoints": "#a88f59",
  "rougebaiser": "#EF3C2E",
  "sakura": "#F26CAE",
  "tropiques": "#F2622D",
  "jasmine": "#F5F5F5",
  "plume": "#F5F5F5",
  "makeup": "#F3C0CF",
  "Make Up": "#F3C0CF",
  "dahlia": "#EF3C2E",
  "rotin": "#eb5e00",
  "spirit": "#20B2AA",
  "acide": "#ffff7c",
  "tempête": "#525252",
  "poupi": "#03224C",
  "berries": "#F1E6C8",
  "pinata": "#03224C",
  "prairie": "#59BF1E",
  "abricotier": "#fabea2",
  "cosmic": "#1B72C7",
  "bakelite": "#F7D7D8",
  "sailor": "#03224C",
  "ecru35": "#FEFEE0",
  "ecru34": "#FEFEE0",
  "ecru15": "#FEFEE0",
  "ecru24": "#FEFEE0",
  "blue58": "#195ABC",
  "blue5": "#195ABC",
  "blue35": "#195ABC",
  "gris04": "#d4d4d4",
  "grispoussiere": "#5b5b5b",
  "gris05": "#d4d4d4",
  "terahertz": "#d4d4d4",
  "blue4": "#195ABC",
  "navy00": "#03224C",
  "navy50": "#03224C",
  "navy44": "#03224C",
  "navy47": "#03224C",
  "navy58": "#03224C",
  "adelekaki": "#625510",
  "adeniaencre": "#0c1a66",
  "adrianegreen": "#419F32",
  "aidableu": "#195ABC",
  "almamarine": "#021836",
  "almanoir": "#000000",
  "amabellaorange": "#F2622D",
  "anaisrouille": "#de6b54",
  "rust": "#9b352d",
  "antracitechine": "#585351",
  "army": "#625510",
  "atonavert": "#419F32",
  "avocado": "#568203",
  "babettableu": "#195ABC",
  "bandinibleu": "#195ABC",
  "bengalepomme": "#568203",
  "berryvert": "#419F32",
  "cranberry": "#ba3225",
  "pastèque": "#a31d3d",
  "kiwi": "#255731",
  "borakiwi": "#255731",
  "bluebubblegum": "#38a4d6",
  "rosebubblegum": "#e3498e",
  "plainhotpink": "#e3498e",
  "bibakaki": "#625510",
  "bibavert": "#419F32",
  "bimanuit": "#1b203a",
  "biscuit": "#BF8A3D",
  "ble": "#e8d630",
  "bleuet": "#195ABC",
  "bloomecru": "#FEFEE0",
  "boisderose": "#F26CAE",
  "brownie": "#BF8A3D",
  "calviforet": "#1E4728",
  "campaorange": "#F2622D",
  "caratkaki": "#625510",
  "carmenmarine": "#021836",
  "carmenrose": "#F26CAE",
  "casavert": "#419F32",
  "cassiabrun": "#BF8A3D",
  "cassiafushia": "#ae2865",
  "cassianoir": "#000000",
  "cassis": "#2A0E14",
  "cecilemarine": "#021836",
  "charlottenoir": "#000000",
  "clairerose": "#F26CAE",
  "clairevert": "#419F32",
  "ebene": "#353534",
  "ebène": "#353534",
  "sanguine": "#850606",
  "clarissebleu": "#195ABC",
  "clematitenuit": "#1b203a",
  "comeindigo": "#1c1154",
  "jeanindigo": "#1c1154",
  "cometenoir": "#000000",
  "constanceecru": "#FEFEE0",
  "constanceemeraude": "#7a8a54",
  "deliacamel": "#BF8A3D",
  "deliarouge": "#EF3C2E",
  "electric": "#002FA7",
  "emmeraude": "#7a8a55",
  "encrechine": "#0c1a66",
  "figueraindigo": "#1c1154",
  "fizabordeau": "#861E15",
  "fizanoir": "#000000",
  "fizarose": "#F26CAE",
  "foret": "#1E4728",
  "garden": "#419F32",
  "geminaorange": "#F2622D",
  "giannanoir": "#000000",
  "green": "#419F32",
  "grisch": "#d4d4d5",
  "hildableu": "#195ABC",
  "hildanoir": "#000000",
  "noirliégé": "#000000",
  "horiablack": "#000000",
  "horiaebene": "#353534",
  "ilyanoir": "#000000",
  "ilyavert": "#419F32",
  "imaneebene": "#353534",
  "indigochine": "#1c1154",
  "iris": "#642469",
  "irmanoir": "#000000",
  "jadeblush": "#00866e",
  "japaneseframboise": "#F1508D",
  "leonablush": "#4a1106",
  "lesliebleu": "#195ABC",
  "leslieforet": "#1E4728",
  "lilaschine": "#fce1f6",
  "lilithcanard": "#048b9a",
  "lipikableu": "#195ABC",
  "lipikamarine": "#021836",
  "lipikarouge": "#EF3C2E",
  "liseforêt": "#1E4728",
  "liviabordeau": "#861E15",
  "liviaforet": "#1E4728",
  "livianoir": "#000000",
  "livymarine": "#021836",
  "lucieemeraude": "#7a8a54",
  "lucierose": "#F26CAE",
  "lupinforet": "#1E4728",
  "magnoliaabricot": "#fabea2",
  "malabar": "#fc9da2",
  "matisreglisse": "#4a3839",
  "melinamarine": "#021836",
  "melinanoir": "#000000",
  "midnight": "#0f388a",
  "minachocolat": "#5A3A22",
  "miragenuit": "#1b203a",
  "mirageorange": "#F2622D",
  "mirandanoir": "#000000",
  "réglisse": "#000000",
  "mishableu": "#195ABC",
  "missacanelle": "#9e621e",
  "mitalibleu": "#195ABC",
  "mitaliforet": "#1E4728",
  "nadiaframboise": "#F1508D",
  "nadiafushia": "#ae2865",
  "nadiakaki": "#625510",
  "nanettereglisse": "#4a3839",
  "navy": "#021836",
  "poppypapaya": "#56629B",
  "nougat": "#fdfae9",
  "plainimperial": "#346AC0",
  "kireskyway": "#C2AFE5",
  "nympheableu": "#195ABC",
  "nymphearouge": "#EF3C2E",
  "ocelotcanelle": "#9e621e",
  "ocelotnoir": "#000000",
  "oeilletbleu": "#195ABC",
  "oeilletmarine": "#021836",
  "oeilletnoir": "#000000",
  "ohaforet": "#1E4728",
  "orionbleu": "#195ABC",
  "orionecru": "#FEFEE0",
  "paisleynoir": "#000000",
  "paisleysanguine": "#EF3C2E",
  "pepitenoir": "#000000",
  "plainblack": "#000000",
  "Pétrol": "#6a7e85",
  "philovert": "#419F32",
  "phoenixkaki": "#625510",
  "piment": "#EF3C2E",
  "pink": "#f0b4b7",
  "pipacanelle": "#9e621e",
  "pipaframboise": "#F1508D",
  "piparoi": "#318ce7",
  "poppymarine": "#021836",
  "poudrechine": "#fce6eb",
  "poussin": "#d4bb61",
  "prayarouge": "#EF3C2E",
  "prismeframboise": "#F1508D",
  "prismenoir": "#000000",
  "prunechine": "#89274B",
  "purple": "#592B87",
  "raphaelnuit": "#1b203a",
  "roi": "#318ce7",
  "sahara": "#E4DCC9",
  "samaelbleu": "#195ABC",
  "satigreen": "#419F32",
  "sea": "#1c2842",
  "shirinecru": "#FEFEE0",
  "shirinnoir": "#000000",
  "noircroco": "#000000",
  "simonrose": "#F26CAE",
  "sitanoir": "#000000",
  "solaneorange": "#F2622D",
  "solangeforet": "#1E4728",
  "starvert": "#419F32",
  "stone": "#928e85",
  "storm": "#64718f",
  "sylviamarine": "#021836",
  "sylviavert": "#419F32",
  "tamieforet": "#1E4728",
  "terryforet": "#1E4728",
  "terryframboise": "#F1508D",
  "terryfushia": "#ae2865",
  "timyvert": "#419F32",
  "tomato": "#EF3C2E",
  "tournesolbleu": "#195ABC",
  "ushableu": "#195ABC",
  "ushaecru": "#FEFEE0",
  "ushaolive": "#558E0E",
  "ushaturquoise": "#06c6ff",
  "ushavert": "#419F32",
  "vidamarine": "#021836",
  "vidishacanard": "#048b9a",
  "vidishavert": "#419F32",
  "xenianuit": "#1b203a",
  "yolandaforet": "#1E4728",
  "yolandavert": "#419F32",
  "zelmaroi": "#318ce7",
  "burgundyred": "#6B0D0D",
  "moss": "#625510",
  "onyxblack": "#000000",
  "mintyfresh": "#b0f2b6",
  "granitegrey": "#374345",
  "cherryred": "#D2042D",
  "electricblue": "#003399",
  "purplerain": "#7442c8",
  "aqua-happy": "#C6F0F5",
  "argile": "#E2725B",
  "argile-mom": "#E2725B",
  "beige-dad": "#F1E6C8",
  "beige-dream": "#F1E6C8",
  "beigeetblanc": "#F1E6C8",
  "beige-home": "#F1E6C8",
  "beige-hygge": "#F1E6C8",
  "beige-life": "#F1E6C8",
  "beige-love": "#F1E6C8",
  "beige-mom": "#F1E6C8",
  "beige-papa": "#F1E6C8",
  "beige-pappa": "#F1E6C8",
  "beige-xmas": "#F1E6C8",
  "beige-yourock": "#F1E6C8",
  "blanc-hi": "#F5F5F5",
  "blanc-mom": "#F5F5F5",
  "bleuciel-love": "#9EC3E0",
  "mixoxfordbleu": "#9EC3E0",
  "bleuclair-hohoho": "#DCF4F7",
  "bleuclair-hope": "#DCF4F7",
  "bleuclair-hygge": "#DCF4F7",
  "bleuclair-jinglebells": "#DCF4F7",
  "bleuclair-mom": "#DCF4F7",
  "bleuclair-peace": "#DCF4F7",
  "bleuclair-superstar": "#DCF4F7",
  "bleucobalt": "#0047AB",
  "bleucobalt-dream": "#0047AB",
  "bleucobalt-happy": "#0047AB",
  "bleucobalt-hello": "#0047AB",
  "bleucobalt-love": "#0047AB",
  "bleu-dad": "#195ABC",
  "bleu-dl": "#195ABC",
  "bleuetnacré": "#195ABC",
  "bleufoncé-life": "#0F056B",
  "bleu-granddad": "#195ABC",
  "bleu-letitsnow": "#195ABC",
  "bleu-love": "#195ABC",
  "bleu-mom": "#195ABC",
  "camel-relax": "#BF8A3D",
  "corail-love": "#E73E01",
  "corail-mom": "#E73E01",
  "create": "#F26CAE",
  "grisclair-dream": "#E6E6E6",
  "grisclair-xmas": "#E6E6E6",
  "gris-dad": "#D4D4D4",
  "grisetbeige": "#D4D4D4",
  "grisetblanc": "#D4D4D4",
  "grisfoncé-hello": "#808080",
  "gris-friend": "#D4D4D4",
  "gris-hi": "#D4D4D4",
  "gris-smile": "#D4D4D4",
  "gris-work": "#D4D4D4",
  "gris-yourock": "#D4D4D4",
  "jaune-dl": "#FEDF4B",
  "jaune-happy": "#FEDF4B",
  "lavande-hey": "#E0C8DA",
  "lavande-kiss": "#E0C8DA",
  "lavande-life": "#E0C8DA",
  "lavande-love": "#E0C8DA",
  "lavande-yourock": "#E0C8DA",
  "lavender": "#E0C8DA",
  "lilas-happy": "#FCE1F6",
  "lilas-mom": "#FCE1F6",
  "lilas-tothemoon": "#FCE1F6",
  "moutarde-hygge": "#B49B17",
  "moutarde-sunshine": "#B49B17",
  "noir-doré": "#000000",
  "noiretblanc": "#000000",
  "noir-hot": "#000000",
  "noir-smile": "#000000",
  "noir-snack": "#000000",
  "noir-weekend": "#000000",
  "noir-yourock": "#000000",
  "nude-goodies": "#FBC398",
  "nude-love": "#FBC398",
  "nude-mom": "#FBC398",
  "œildetigre": "#4D2E0F",
  "olive-dream": "#558E0E",
  "olive-life": "#558E0E",
  "orange-freedom": "#F2622D",
  "orange-hero": "#F2622D",
  "orange-love": "#F2622D",
  "imprimefleuri": "#F2622D",
  "orange-power": "#F2622D",
  "orange-togo": "#F2622D",
  "orang-hello": "#F2622D",
  "rhodochrosite": "#F26CAE",
  "rose-celebrity": "#F26CAE",
  "rose-dl": "#F26CAE",
  "roseetbleu": "#F26CAE",
  "roseetnacré": "#F26CAE",
  "rosefluo-life": "#FA07A9",
  "rosefoncé-amour": "#E3C1B3",
  "rosefoncé-darling": "#E3C1B3",
  "rosefoncé-happy": "#E3C1B3",
  "rosefoncé-love": "#E3C1B3",
  "rosefoncé-mom": "#E3C1B3",
  "rose-hello": "#F26CAE",
  "rose-kiss": "#F26CAE",
  "rose-love": "#F26CAE",
  "rose-mom": "#F26CAE",
  "rose-smile": "#F26CAE",
  "rose-sweeth": "#F26CAE",
  "rougeetbleuciel": "#EF3C2E",
  "rouge-heysanta": "#EF3C2E",
  "rouge-hohoho": "#EF3C2E",
  "rouge-jinglebells": "#EF3C2E",
  "rouge-yourock": "#EF3C2E",
  "study": "#048B9A",
  "terracotta-love": "#E2725B",
  "turquoise-life": "#06C6FF",
  "turquoise-yourock": "#06C6FF",
  "vertclair-love": "#45E660",
  "vertclair-smile": "#45E660",
  "vertclair-xmas": "#45E660",
  "vert-dad": "#419F32",
  "vertdeau-life": "#C1EBD4",
  "vertetrose": "#419F32",
  "vertettransparent": "#419F32",
  "vertfoncé-hey": "#006400",
  "vertfoncé-hygge": "#006400",
  "vertfoncé-life": "#006400",
  "vertfoncé-soulmate": "#006400",
  "vertfoncé-togo": "#006400",
  "vertfoncé-yourock": "#006400",
  "vertforêt": "#315D49",
  "vert-happyxmas": "#419F32",
  "vert-hi": "#419F32",
  "vert-hohoho": "#419F32",
  "vert-love": "#419F32",
  "vert-smile": "#419F32",
  "vertt": "#419F32",
  "vert-togo": "#419F32",
  "verty": "#45E660",
  "verty-like": "#45E660",
  "vert-yourock": "#419F32",
  "violet-darling": "#592B87",
  "violet-dl": "#592B87",
  "violet-dream": "#592B87",
  "violet-love": "#592B87",
  "work": "#D4D4D4",
  "amoremio": "#FFFFFF",
  "bleu": "#0000FF",
  "bleucéladon": "#ACE1AF",
  "bleudenim": "#1B306B",
  "bleupétrole": "#1D4851",
  "blueléo": "#77B5FE",
  "bordeaux": "#800020",
  "boutond'or": "#FF7F00",
  "cacao": "#7B3F00",
  "cannelle": "#D2691E",
  "caramel": "#BF8A3D",
  "carreauazur": "#77B5FE",
  "carreaublancetbleu": "#000080",
  "carreaubleu": "#0000FF",
  "carreaucamel": "#BF8A3D",
  "carreaud'hiver": "#C2B280",
  "carreauischia": "#40E0D0",
  "chevroncaramel": "#BF8A3D",
  "chinébleu": "#6B9AAF",
  "chinégris": "#D3D3D3",
  "clubcaramel": "#BF8A3D",
  "clubcôteléécru": "#C2B280",
  "clubcôtelévert": "#008000",
  "clubvert": "#008000",
  "dunebleue": "#0000FF",
  "dunejaune": "#FFFF00",
  "écureuil": "#582900",
  "graphicocre": "#CC7722",
  "graphicvert": "#008000",
  "gris": "#606060",
  "isla": "#FF00FF",
  "jauneolive": "#E1AD01",
  "justeleblanc": "#FFFFFF",
  "justelegris": "#606060",
  "justelepetitcarreau": "#0000FF",
  "justelerosepoudré": "#EEC4C9",
  "leblanc": "#FFFFFF",
  "lebleu": "#0000FF",
  "legrischambray": "#D3D3D3",
  "lejaune": "#FFFF00",
  "lemarine": "#000080",
  "lemarsala": "#C45824",
  "lementhe": "#16B84E",
  "lenaturel": "#C2B280",
  "lenaturelbleu": "#0000FF",
  "lenaturelterracotta": "#C45824",
  "lerayécrème": "#FDF1B8",
  "lerayéécureuil": "#582900",
  "lerayékaki": "#94812B",
  "lerayénaturel": "#C2B280",
  "lerayéocre": "#CC7722",
  "lerayévert": "#008000",
  "leterracotta": "#C45824",
  "lilas": "#B666D2",
  "marine": "#041947",
  "mauved'été": "#D473D4",
  "miamor": "#FFFFFF",
  "moka": "#F5F5DC",
  "mousse": "#94812B",
  "ocre": "#CC7722",
  "orange": "#FF8000",
  "pinkléo": "#FD6C9E",
  "raisin": "#3E3959",
  "rayéchemise": "#0000FF",
  "rayéolive": "#708D23",
  "rayurebayadère": "#77B5FE",
  "rayureclubbordeaux": "#800020",
  "rayureemeraude": "#01D758",
  "rayurenomade": "#000080",
  "rayurepalace": "#CC7722",
  "rayuresaharaindigo": "#4B0082",
  "rayuresportjaune": "#FFFF00",
  "rayuresportverte": "#008000",
  "shiborisérie1": "#000080",
  "shiborisérie2": "#000080",
  "shiborisérie3": "#000080",
  "siennechambray": "#DCAE96",
  "terracotta": "#C45824",
  "vaguebleue": "#0000FF",
  "vaguerouge": "#FF0000",
  "vertcéladon": "#ACE1AF",
  "verteau": "#B0F2B6",
  "vertmousse": "#94812B",
  "vichylilas": "#B666D2",
  "vieuxrose": "#EEC4C9",
  "antic": "#f2b6a0",
  "brick": "#f28c7e",
  "deepforest": "#333d34",
  "ink": "#4a4948",
  "linen": "#f0e9e1",
  "linen/black": "#1a1a19",
  "milk": "#f7f5f5",
  "mustard": "#f59140",
  "nu": "#f7d2ba",
  "oak": "#f5d6bf",
  "yellow": "#FFFF00",
  "violetbougainvillier": "#EE82EE",
  "superpink": "#cf6ba9",
  "cèdre": "#084010",
  "crocodilenoir": "#0f0f0f",
  "lézardnoir": "#0f0f0f",
  "mogano": "#751621",
  "noirglace": "#2b2a2b",
  "noirglacé": "#2b2a2b",
  "noirvégétal": "#292829",
  "pécan": "#cf8a3c",
  "romarin": "#6e684d",
  "trèfle": "#2d422d",
  "amertrine": "#c9a5c7",
  "ametrine": "#c9a5c7",
  "antique": "#f2f1f0",
  "antiqueblack": "#5c5a5a",
  "ficusleaf": "#345235",
  "flax": "#e6dfd5",
  "flaxnavy": "#171c33",
  "opticalwhite": "#f5f6fa",
  "opticalwhitenavy": "#171c33",
  "seafoammarle": "#a1adad",
  "grisardoise": "#555b61",
  "blancbeige": "#bab1a6",
  "blancfrais": "#FFFFFF",
  "blancbleu": "#43455c",
  "bourdonbleu": "#43455c",
  "rayébleu": "#43455c",
  "rayurebleue": "#43455c",
  "carreauxbleuazur": "#bbeaf2",
  "bleuazurrayé": "#bbeaf3",
  "blancbleuglacier": "#8db1b3",
  "bleumatelot": "#4b81ab",
  "bicolorebleuminuit": "#0f0f42",
  "bleuorage": "#385f7d",
  "bleuturquin": "#233252",
  "bourdonbleuturquin": "#233253",
  "bicolorebordeaux": "#800020",
  "blancbordeaux": "#800020",
  "bourdonbordeaux": "#800020",
  "rayébordeaux": "#800020",
  "griscarbone": "#2e3138",
  "blanc/ficelle": "#dbcb91",
  "mirage": "#5C6D7C",  
  "ficelle/blanc": "#dbcb91",
  "fleuribleu": "#0000FF",
  "fleurirose": "#FFC0CB",
  "vertforet": "#375735",
  "grisgalet": "#8b8f8b",
  "grandcarreaux": "#282928",
  "graphite": "#393b39",
  "grisgraphite": "#393b40",
  "bicoloregreige": "#BBAA99",
  "bourdongreige": "#BBAA99",
  "carreauxgreige": "#BBAA99",
  "passepoilgreige": "#BBAA99",
  "rayégreige": "#BBAA99",
  "greigepassepoilblanc": "#BBAA99",
  "greigerayé": "#BBAA99",
  "blancgris": "#808080",
  "bicoloregrisacier": "#6e7070",
  "bourdongrisacier": "#6e7071",
  "grismoiré": "#808080",
  "bourdonjaune": "#FFFF00",
  "jauneboutondor": "#FFFF00",
  "minicoeurs": "#e33e19",
  "minifleurs": "#0f570f",
  "bicolorenoir": "#000000",
  "blancnoir": "#000000",
  "bourdonnoir": "#000000",
  "passepoilnoir": "#000000",
  "blanc/pierre": "#777a77",
  "pierre": "#777a78",
  "pierre/blanc": "#777a79",
  "rosemacaron": "#c48994",
  "rosethé": "#d48672",
  "vertsauge/blanc": "#81968c",
  "blanc/sienne": "#9c5435",
  "bourdonsienne": "#9c5436",
  "sienne/blanc": "#9c5437",
  "rayétomette": "#8f411f",
  "blancvert": "#008000",
  "bourdonvertanglais": "#405e40",
  "bicolorevertcendré": "#9cb59c",
  "rayévertcendré": "#9cb59c",
  "vertcendré": "#9cb59c",
  "vertcendrépassepoilblanc": "#9cb59c",
  "passepoilvertforêt": "#375735",
  "blanc/vertsauge": "#b1c7b1",
  "noirgraphite": "#181818",
  "blancnuage": "#E8E8E6",
  "vertdegris": "#909583",
  "roseterracotta": "#DDA999",
  "rougegrenat": "#531315",
  "pépited'or": "#C4914C",
  "pepited'or": "#C4914C",
  "pepitedor": "#C4914C",
  "pépitedor": "#C4914C",
  "jauneprimaire": "#D8AF1A",
  "aluminiumbrossé": "#B1B0AB",
  "aluminiumbrosse": "#B1B0AB",
  "orange70's": "#D95A15",
  "orange70s": "#D95A15",
  "bleuprimaire": "#193285",
  "rougeprimaire": "#AD0A0B",
  "bourdonvertsauge": "#b1c7b2",
  "argentémulti": "#b4b6b8",
  "bleuargile": "#83add4",
  "bleucendre-in-argent": "#5f6f7d",
  "bleu-vernis": "#7ec1ed",
  "carmin-in-blush": "#a3374f",
  "céleri": "#cbeba9",
  "etain": "#c2ccb8",
  "fuxiafoncé": "#b31227",
  "galetfonce": "#857d69",
  "galetrosé": "#e8c9ac",
  "grischaud": "#5c5854",
  "jadeantic": "#96c771",
  "jadeantic-in-champagne": "#96c771",
  "jade-vernis": "#96c771",
  "mauvefoncé-mauve-gris": "#9f67a6",
  "multipython": "#ab9b82",
  "naturelpython": "#e6d0ae",
  "noir-galet-champagne": "#050505",
  "noir-galetrosé-cognac": "#050505",
  "noir-multi": "#050505",
  "noirpython": "#050505",
  "noir-vernis": "#050505",
  "oliveincéleri": "#cbeba9",
  "orchidéefoncé": "#a61ea3",
  "paonstone": "#4b9599",
  "potiron": "#d66e06",
  "rose-vernis": "#f0d3ef",
  "vertécolo": "#4b5948",
  "vertmulti": "#4b5948",
  "vison": "#c4a587",
  "01": "#ffffff",
  "abudhabi": "#9f6d5b",
  "alabama": "#763f35",
  "alabaster": "#ddba9e",
  "allbuttadup": "#947268",
  "allthebutta": "#bb41be",
  "almond": "#a36133",
  "almondbutta": "#be814e",
  "alwaysonyx": "#1e1e1e",
  "amberstunner": "#d2a767",
  "ambitionstatement": "#9f5f54",
  "amsterdam": "#a50932",
  "angel'sfoodcake": "#e2808d",
  "anotherlevel": "#9f2953",
  "applepie": "#f1d195",
  "apricaught": "#9f5849",
  "aquamarine": "#3a5a62",
  "ashblonde": "#97704c",
  "ashbrown": "#5a4c40",
  "auburn": "#986b58",
  "backandbutta": "#a03f4d",
  "baddestblack": "#000000",
  "banana": "#ffefd3",
  "banginbare": "#a3655d",
  "bdayfrosting": "#921a67",
  "beigeboost": "#744d3e",
  "berlin": "#000000",
  "berrybedsheets": "#57264b",
  "berrygoth": "#573c4d",
  "berrythirsty": "#781727",
  "bitofhoney": "#a56254",
  "blackbean": "#191919",
  "blackme": "#605e5c",
  "blackmetal": "#242424",
  "blonde": "#816245",
  "blueberrybank": "#174077",
  "blueberrymuffin": "#c769cc",
  "blueberrypop": "#294a6c",
  "bluethang": "#b8d2e6",
  "bluetrip": "#73c9b4",
  "blushrush": "#6a202c",
  "bootcutbling": "#ef8b8b",
  "borntohustle": "#cf7b69",
  "brickoftime": "#752e2a",
  "brickred": "#925350",
  "brightamber+fuschia": "#be5141",
  "bringthebling": "#d8b99f",
  "brown": "#39291a",
  "brownmetallic": "#605e5c",
  "brownofapplause": "#854236",
  "brownshimmer": "#fffff",
  "brunchme": "#ab6866",
  "brunette": "#544131",
  "bubblegumbae": "#c9207a",
  "bubblegumburst": "#6d2432",
  "budapest": "#834049",
  "buff": "#cb9e79",
  "burntsienna": "#fffff",
  "burstthattang!": "#8f332e",
  "bust-ed": "#794351",
  "buttaballin": "#995f46",
  "buttabiscuit": "#8b685f",
  "buttabling": "#e8c076",
  "buttacup": "#ad847b",
  "buttadayz": "#794c48",
  "buttaddown": "#965742",
  "buttainblack": "#9c5f9d",
  "buttainbronze": "#d8a675",
  "buttamatch": "#81402c",
  "buttamint": "#daf9e4",
  "buttaoff": "#825b51",
  "buttathanbefore": "#a63861",
  "buttathangold": "#f7eeb6",
  "buttathanu": "#523532",
  "buttatogether": "#f791ac",
  "butterscotch": "#8f665c",
  "cairo": "#000000",
  "candelababe": "#a55343",
  "cannes": "#aa5961",
  "capetown": "#8c6654",
  "cappuccino": "#935c3b",
  "captionthis": "#a35757",
  "capuccino": "#935c3b",
  "carameldrip": "#8c4933",
  "cashewbutta": "#c18459",
  "cashflow": "#b66c6d",
  "chaibutta": "#9b6239",
  "chartreuse": "#c8c38c",
  "cherrycreme": "#aa1433",
  "cherryspice": "#b33241",
  "chestnut": "#543222",
  "chillblue": "#92acd1",
  "chillinlikeavil": "#984652",
  "chocolatebutta": "#331c10",
  "chocolatemousse": "#652236",
  "cinnamon": "#b87f56",
  "citruschiller": "#fffff",
  "classictan": "#c19170",
  "clear": "#ffffff",
  "clearlyspicy": "#d57403",
  "clementinefine": "#c88672",
  "clinger": "#b51f66",
  "clout": "#e67e8c",
  "cobaltcrush": "#4f7297",
  "cocoa": "#70422a",
  "cocoaquench!": "#59351d",
  "coconutcake": "#f1baa2",
  "coldbrew": "#5e3a36",
  "comethrucoconut": "#dcd8d4",
  "coolashbrown": "#76645b",
  "coolblond": "#a1877f",
  "copenhagen": "#000000",
  "coral+deeppeach": "#ab554e",
  "cosmicyellow": "#f2b735",
  "cottagevheese": "#e3e2de",
  "cranberrysplash": "#64101a",
  "cremebrulée": "#f8acaf",
  "cyansimp": "#617878",
  "daringdamsel": "#c66e4e",
  "darkbrown": "#4e3524",
  "darkchocolate": "#392b23",
  "darkpeach": "#d79977",
  "dashofcocoa": "#643a36",
  "deep": "#70422c",
  "deepbronze": "#824637",
  "deepbrown": "#3c2d22",
  "deepcool": "#663f2b",
  "deepebony": "#4c281b",
  "deepespresso": "#573125",
  "deepestbrown": "#463b32",
  "deepgolden": "#ac7644",
  "deepmagenta+ginger": "#9b545d",
  "deepmesh": "#472221",
  "deeprich": "#70422c",
  "deepsable": "#875d3d",
  "deepwalnut": "#63341f",
  "denimdazzle": "#1e364e",
  "deservebutta": "#9d776c",
  "disrupter": "#152772",
  "dmme": "#993961",
  "dobutta": "#714d42",
  "don'tpinktwice": "#cd4e95",
  "doubledose": "#402f2c",
  "doubletap": "#9e003d",
  "drippedpout": "#ce7d6b",
  "drippin'inrose": "#5f2029",
  "duckingclear": "#ffffff",
  "eggplant": "#fffff",
  "emeraldcut": "#628a38",
  "emeraldempire": "#394336",
  "espresso": "#4a3f36",
  "espressosoak": "#39241a",
  "evilgenius": "#101820",
  "fair": "#d5a286",
  "fauxfur": "#89594a",
  "feedworthy": "#744331",
  "feelingrape": "#6c3f75",
  "fierceflirt": "#b06f76",
  "fillem'in": "#693b3f",
  "firstbaseprimerspray": "#ffffff",
  "flan": "#d3924c",
  "flashyflare": "#807d83",
  "flauntit": "#ac6771",
  "flippin'slime": "#d28b27",
  "flirtyflip": "#833640",
  "followback": "#c1644c",
  "frappe": "#52433a",
  "freespirit": "#9e645a",
  "frenchfries": "#845939",
  "fringeglam": "#000000",
  "frosting": "#cdb39f",
  "fuzzyslippers": "#772e4a",
  "gettin'caliente": "#dc582a",
  "ghostedgreen": "#809558",
  "gingersnap": "#b57367",
  "girlbye": "#6b2c4a",
  "glazeitbutta": "#eacea6",
  "glitzyguava": "#d3a263",
  "globalcitizen": "#956c58",
  "goalcrusher": "#a66a57",
  "goalgetter": "#984857",
  "goin'desnuda": "#623412",
  "goinglive": "#ffffff",
  "goingviral": "#782e2c",
  "goldengoji": "#cda88f",
  "goldenhoney": "#bf8558",
  "goldenlight": "#b9855b",
  "goldplated": "#b7926c",
  "grahamcracker": "#895e4d",
  "grapefruitglow": "#dcb7b7",
  "grapegushin'": "#191419",
  "graphicpurple": "#9277a0",
  "graphiteglitz": "#4b4849",
  "groupchat": "#9c5b4e",
  "gunmetal": "#00000",
  "hadmeatyellow": "#f4cf67",
  "hallofflame": "#8f0028",
  "hazelnutbutta": "#4c2918",
  "highkeylychee": "#dfc5b5",
  "hitsdifferent": "#ad563b",
  "hollyberryswirl": "#9f6d86",
  "honeyorange+rose": "#d6866a",
  "hotcaramelo": "#8f583b",
  "hotcocoaswirl": "#9b6859",
  "hottiehijacker": "#a83d72",
  "hustla": "#603f36",
  "hydra-honey": "#75393b",
  "icedlatte": "#be998d",
  "icedmocha": "#81694f",
  "icingontop": "#d01526",
  "inamood": "#5c101b",
  "incharge": "#72294b",
  "insidescoop": "#622827",
  "intenseteal": "#177f67",
  "inthedrafts": "#6e213a",
  "istanbul": "#895859",
  "it'shotter": "#79262f",
  "java": "#402c2b",
  "kittybelly": "#97584f",
  "kiwifreeze": "#fffff",
  "knockout": "#b5478e",
  "lattefoam": "#7e4944",
  "laundryday": "#a47269",
  "lavacake": "#4c2a1e",
  "leadeverything": "#b50056",
  "leavealegacy": "#96514c",
  "lemonmeringue": "#e69f76",
  "leon": "#774d41",
  "lifegoals": "#944a40",
  "light": "#cda769",
  "lightivory": "#efc7aa",
  "lightmedium": "#b98c69",
  "lightpeach+babypink": "#c1686c",
  "lightporcelain": "#fccab7",
  "lighttan": "#c48f6b",
  "lilac": "#a380af",
  "lilaclink": "#c6acd9",
  "lilaconlock": "#874852",
  "liltoasty": "#d1a183",
  "linkinmybio": "#703126",
  "livinthecream": "#573225",
  "london": "#97684c",
  "losangeles": "#795855",
  "losangeles2.0": "#6d5049",
  "losinconetrol": "#792119",
  "lowcut": "#693932",
  "ltneutral": "#d9b199",
  "madeleine": "#e29784",
  "madrid": "#000000",
  "mahogany": "#a16a49",
  "makeastatement": "#5a2925",
  "makeitwork": "#b06782",
  "mangomoment": "#ad8378",
  "marshmellow": "#f0d0e7",
  "mauven'moist!": "#39151c",
  "maxxout": "#9c5e6b",
  "medium": "#c39367",
  "mediumbrown": "#663f34",
  "mediumbuff": "#cb9374",
  "mediumdark": "#b37048",
  "mediumgolden": "#c8996f",
  "mediumneutral": "#bb8461",
  "mediumolive": "#cf9b73",
  "mediumtan": "#a76947",
  "mediumvanilla": "#e4b99e",
  "midnightrise": "#2c3d61",
  "milan": "#895859",
  "milkchocolate": "#331901",
  "missedcall": "#eb6994",
  "mocha": "#784529",
  "mochamecrazy": "#703d30",
  "mochamewet": "#46241f",
  "montecarlo": "#8d2642",
  "montreal": "#895859",
  "moviemaker": "#bd3742",
  "movin'up": "#bd5e71",
  "mybuttahalf": "#eb6ab9",
  "mymain": "#ffffff",
  "natural": "#d8a380",
  "neutralbuff": "#c4895d",
  "neutraltan": "#b0784d",
  "neverbasic": "#623240",
  "newsfeed": "#be0b37",
  "nextgenthinking": "#654e4d",
  "noequivalent": "#834e3c",
  "nofilterneeded": "#994345",
  "nonapplicable": "#fffff",
  "nowine-ing": "#3f1e1a",
  "nudeflip": "#774740",
  "nudeswings": "#9b5355",
  "nutmeg": "#8b5239",
  "nutmegbutta": "#6b3e23",
  "olive": "#766f5d",
  "onamission": "#b83a4b",
  "onfuego": "#e10600",
  "onyx-pected": "#3c3122",
  "orangezest": "#f28172",
  "overnighthero": "#8d6267",
  "pale": "#fed4b1",
  "pancakestacks": "#c05261",
  "parfait": "#8e4343",
  "passionfruitposh": "#b46a5e",
  "paymeingold": "#7b4b2c",
  "peach": "#daa78b",
  "peachflirt": "#a7544b",
  "peachout": "#fc4332",
  "pearprize": "#9b625b",
  "peekshow": "#7c3f53",
  "peppermintswirl": "#6f1b28",
  "periwinklepop": "#c3b0ce",
  "pickmepink": "#9c3b60",
  "pillowfight": "#d10f5a",
  "pinkhit": "#a22261",
  "pinkjection": "#964852",
  "pinkspirit": "#c5628e",
  "pitchblack": "#000000",
  "polarpeppermint": "#fffff",
  "porcelain": "#d8b5a1",
  "prague": "#000000",
  "praline": "#aa6c65",
  "pralinebutta": "#a16639",
  "pricey": "#bc5e3e",
  "profilepic": "#854b4b",
  "prune": "#672f43",
  "pureplump": "#472040",
  "purewhite": "#ffffff",
  "push'dup": "#924f5f",
  "pushincushion": "#934f47",
  "quartzqueen": "#efd0c2",
  "quazysilver": "#948f82",
  "queen": "#e3cda7",
  "rebelinred": "#c10016",
  "rebelkind": "#674736",
  "red-y.set.wet!": "#84001c",
  "red": "#7b1017",
  "regular": "#ffffff",
  "rich": "#674230",
  "richauburn": "#8d4742",
  "rockyroad": "#67001b",
  "rome": "#874745",
  "sanfrancisco": "#864f46",
  "sanpaulo": "#fe4e62",
  "sapphire": "#375fa9",
  "sapphirebling": "#1e253a",
  "sassy": "#834343",
  "scrollin": "#773213",
  "selftaughtmillionaire": "#1c3a41",
  "shakethingsup": "#60375e",
  "sheer": "#f18093",
  "shegotmoney": "#bf4963",
  "sherbet": "#ffabb4",
  "shimmerdown": "#a3462b",
  "shimmerstitch": "#906d7c",
  "sienna": "#8e5c38",
  "silvermetallic": "#605e5c",
  "sixfigs": "#b46a5e",
  "sizzlin'": "#600c1e",
  "smokin'topaz": "#3a2f30",
  "sneakypink": "#e8a5cf",
  "softbeige": "#d6a483",
  "sorbet": "#d25965",
  "spicy": "#a51d34",
  "spicypearl": "#935b4f",
  "spikedtoffee": "#8b5c57",
  "splashnspice": "#5f3f2d",
  "splashofcream": "#843f37",
  "sprinklesprinkle": "#672e2e",
  "stamina": "#83002b",
  "statusupdate": "#3a0300",
  "stayinjuicy": "#832d4c",
  "staystuntin'": "#dc3513",
  "stockholm": "#b27c6b",
  "stonefox": "#394049",
  "storyorpost": "#c66d67",
  "strapsoff": "#652d2b",
  "strawberrystacked": "#d12b4c",
  "strikearose": "#96364d",
  "stripntease": "#6e393c",
  "subtletouch": "#6f473d",
  "sugarcookieswirl": "#b07469",
  "sugarhigh": "#b77464",
  "supermodel": "#de1064",
  "sweettooth": "#951f57",
  "swollenspice": "#803d36",
  "tan": "#c58b68",
  "taperedtwinkle": "#2c657f",
  "tealmetal": "#605e5c",
  "teddyfluff": "#8e5a51",
  "tenoutoften": "#833739",
  "that'schic": "#7d1a47",
  "that'smajor": "#6e213a",
  "thriving": "#cc0070",
  "tiger'sprize": "#a96150",
  "tiramisu": "#c1726d",
  "toffeebutta": "#88502d",
  "tooblessed": "#6a413a",
  "totalballer": "#7c4d3a",
  "touchuptaupe": "#634b3f",
  "toulouse": "#9b6261",
  "translucen": "#ffffff",
  "translucent": "#ffffff",
  "translucide": "#ffffff",
  "transparente": "#e7c5a7",
  "trendingtopic": "#4d2e27",
  "trophylife": "#a85566",
  "truebeige": "#ddba9e",
  "truffle": "#8e4c38",
  "trufflediamond": "#3c3537",
  "turnon": "#a36157",
  "turquoisestorm": "#1e6e94",
  "twicethespice": "#4f2b24",
  "underthemoonstone": "#5c4742",
  "undress'd": "#a76b64",
  "unhooked": "#906968",
  "universallight": "#dbb790",
  "unlaced": "#88475b",
  "untamable": "#c8102e",
  "vanilla": "#e8bb99",
  "vanillabeanbutta": "#d19a6d",
  "vanillaicecream": "#ffffff",
  "verified": "#8c4e40",
  "vintagebaby": "#00a6e5",
  "walnut": "#633816",
  "warmcaramel": "#a0613f",
  "warmhoney": "#aa714b",
  "warmmahogany": "#8f4f23",
  "warmup": "#8d4844",
  "warmvanilla": "#b77854",
  "warmwalnut": "#542d26",
  "water'boutwine?": "#300a0d",
  "watermelonwealth": "#3c816a",
  "whippedbutta": "#ebb388",
  "winenot": "#612622",
  "worldshaper": "#ad003e",
  "xxposeme": "#aa5d5e",
  "xxtended": "#792543",
  "yogurt": "#bf9986",
  "zurich": "#000000",
  "amber": "#d4a25a",
  "amberecru": "#e2c59c",
  "ashrose": "#c49b9b",
  "beigedark": "#b6a27f",
  "blackblue": "#0a0f1a",
  "blackmelange": "#2b2b2b",
  "blackplush": "#1a1a1a",
  "blackpois": "#101010",
  "blackpolar": "#1f1f29",
  "blackvelour": "#1e1b1c",
  "bondi": "#0095b6",
  "bondialmond": "#b9a68d",
  "brush": "#d9cfc4",
  "cameo": "#e6bea5",
  "chocogris": "#7b6653",
  "chocopecan": "#5a3e36",
  "cognacquilted": "#a0522d",
  "ecrupecan": "#c8b393",
  "eveninggreen": "#2e4a3e",
  "greyarctic": "#aab5c0",
  "greyblack": "#3a3a3a",
  "grispecan": "#998675",
  "hotpink": "#ff69b4",
  "housesteal": "#2c7c7d",
  "iridescent": "#cfd8dc",
  "lakeblue": "#4f97a3",
  "lightgrey": "#d3d3d3",
  "matcha": "#c2d4aa",
  "metalliccharcoal": "#3d3d3d",
  "metallicgrey": "#7a7a7a",
  "oat": "#e6d8b6",
  "oliveblue": "#4a646c",
  "olivemulticolor": "#8d8f6a",
  "pearl": "#f8f6f0",
  "pecan": "#a0522d",
  "pecanamber": "#b47036",
  "pecanchartreuse": "#d1c84c",
  "pecanchoco": "#5a3825",
  "pecanecru": "#d1b195",
  "pinkvelour": "#e48ca4",
  "rosechoco": "#b07b79",
  "rosedawn": "#f4c2c2",
  "rosegrey": "#b5a1a1",
  "seashell": "#fff5ee",
  "seashellblue": "#b3dce6",
  "smokey": "#726e6d",
  "spice": "#cb6843",
  "spicequilted": "#a65639",
  "starswhite": "#ffffff",
  "starsyellow": "#fff700",
  "stella": "#e0e0e0",
  "stellagrand": "#c0c0c0",
  "treesbeige": "#d6c9ad",
  "treespink": "#f0b7b3",
  "tropicalraspbe": "#F10088",
  "amande": "#A8C1A7",
  "gayaxagathesorlet": "#4B9E97",
  "mediterraneanblue": "#06B0D3",
  "motherofpearl": "#E4E4E4",
  "clearred": "#CD2E29",
  "milkwhite": "#EFE8DF",
  "redwhitetransparent": "#E4042D",
  "blackwhitetransparentred": "#FEF2F4",
  "bluewhiteorange": "#A9ACAF",
  "greywhitesaffron": "#BDC3BF",
  "yellowwhiteaquamarine": "#D7DDD1",
  "lightbluewhiteblue": "#A3BFD0",
  "mauve/white/caramel": "#FBEFEB",
  "mauvewhitecaramel": "#FBEFEB",
  "yellow/white/waterlilygreen": "#FEF07F",
  "yellowwhitewaterlilygreen": "#FEF07F",
  "matchagreen/white/mauve": "#D6BEB8",
  "matchagreenwhitemauve": "#D6BEB8",
  "pearl/white/pearl": "#ECEAE3",
  "pearlwhitepearl": "#ECEAE3",
  "red/white/emerald": "#39894C",
  "redwhiteemerald": "#39894C",
  "greywhiteyellow": "#8B9697",
  "sandwhitemossgreen": "#D4CDC5",
  "saffronyellow/white/waterlilygreen": "#FFF471",
  "saffronyellowwhitewaterlilygreen": "#FFF471",
  "mattblue": "#B6CCDE",
  "flamingopink": "#F2C4C8",
  "sand": "#977D54",
  "powderblue": "#79A1AC",
  "mattmidblue": "#838E90",
  "ochre": "#FDC023",
  "brightred": "#E8252E",
  "mangoyellow": "#D99E30",
  "peachblossompink": "#C89589",
  "avocadogreen": "#979858",
  "britishracinggreen": "#27695C",
  "sapphireblue": "#405575",
  "mattgrey": "#544C48",
  "brightmustardyellow": "#DDB971",
  "brightpowderblue": "#3BAFD9",
  "acidyellow": "#EBD695",
  "applegreen": "#BCCE51",
  "chrome": "#CDCDCF",
  "artistnico": "#DBB39C",
  "artistskolp": "#EBECE2",
  "artistdiial": "#C2C2C2",
  "artistetnik": "#B36D26",
  "artistzeus": "#D3A59E",
  "artistmisterthoms": "#D5DCE3",
  "ceruleanblue": "#41748C",
  "jardin": "#8492C8",
  "bluejean": "#92A7C7", 
  "iceberg": "#C9DBEA",
  "melon": "#FBC098",
  "tomate": "#EE5637",
  "ginger": "#FFA07D",
  "cactus": "#45BB98",
  "pixelcamo": "#DCD0D0",
  "monogramme": "#0D0A0E",
  "tartan": "#BD0920",
  "botania": "#FAEEF7",
  "anemone": "#807D79",
  "bandana": "#7888B7",
  "geranium": "#FF8891",
  "granite": "#9D827B",
  "bloom": "#F38261",
  "daisy": "#E8D5D0",
  "vichyrose": "#EFE4EB",
  "acierinoxydable": "#b8bab6",
  "griscolombe": "#8d989e",
  "nature": "#d8e6ed",
  "newleopard": "#E0B095",
  "pythonkaki": "#8F7F72",
  "crocbordeaux": "#714B4C",
  "lézardnoisette": "#E29271",
  "lezardchataigne": "#492123",
  "epice": "#AB6338",
  "lezardnoir": "#231F28",
  "crocnoir": "#232325",
  "crocpraline": "#DC5A85",
  "crocacajou": "#481F19",
  "empire": "#2D4240",
  "ébène": "#3A302D",
  "denimbrut": "#202336",
  "teddynoir": "#030303",
  "teddycreme": "#DCD5D0",
  "teddycrème": "#DCD5D0",
  "grège": "#AF9E88",
  "ébènegrainé": "#39312A",
  "denimblue": "#495D7F",
  "passion": "#7F232E",
  "aquasilver": "#a9b0b0",
  "croctrèfle": "#3E5A58",
  "bordeauxgrainé": "#8F575E",
  "blancargile": "#D4CDCD",
  "bleuplume": "#6A7585",
  "jaunesoleil": "#BCA255",
  "marronfoncé": "#4C3F3A",
  "crocivoire": "#CFBAA6",
  "croccerise": "#7C2131",
  "noirsafiano": "#151618",
  "noirreptile": "#151618",
  "lézardkiwi": "#d4b020",
  "petrolegrainé": "#2c5aa3",
  "toilenoisette": "#904D0A",
  "chaudron": "#66452B",
  "sapin": "#027F80",
  "jaunefoncé": "#B79418",
  "rosegold": "#D89596",
  "cloud": "#F1ECDB",
  "meteo": "#B9EACF", 
  "marbre": "#E2DFD4",
  "arancia": "#F67010", 
  "metal": "#878282", 
  "kaki/beige": "#ADA488", 
  "marine/beige": "#353E46", 
  "tatan/beige/kaki/bleu": "#75897B",
  "cashew": "#B59D7D",
  "sodaauxmyrtilles": "#79A0A7",
  "mangolassi": "#E0A850",
  "pinklimonade": "#E28793",
  "matchalatte": "#B0B667",
  "greentea": "#4A4F4C",
  "hotchoc": "#3B3533",
  "redwine": "#53292B",
  "vertmenthe": "#D6EAD5",
  "lichen": "#B3A158",
  "saphir": "#0090EB",
  "jacinthe": "#D4B6DE",
  "nero": "#222222",
  "bluejeans": "#90B8D5",
  "nocciola": "#E89A5A",
  "grigio": "#3B4E59",
  "bosco": "#619779",
  "trooper": "#87AEBB",
  "salva": "#BCC8B9",
  "rosa": "#FEE2E3",
  "ceramic": "#00CACD",
  "bodacious": "#EDC3E3",
  "snow": "#D7D5D2",
  "orchidflower": "#CB4385",
  "chêne": "#EFDDC5",
  "grisclair-in-argent": "#cfcbc6",
  "taupe-in-or": "#dbc2a2",
  "camelfoncé": "#a3610b",
  "gingembre": "#e3d888",
  "rosefumé": "#e8cada",
  "galetfoncé": "#ab9b8e",
  "orpâle-lézard": "#e3e0de",
  "olive-lézard": "#99a694",
  "abricot-lézard": "#d19b4f",
  "marron-in-orpâle": "#362612",
  "lightpinkandorangelining": "#CE6279",
  "darkblue": "#033087",
  "darkgreen": "#046E3A",
  "lightgreen": "#84D021",
  "black": "#222222",
  "brown": "#4D3A31",
  "lightgrey": "#C2BBAF",
  "lightpink": "#D66C82",
  "red": "#AA1C2C",
  "lightgreyandbluelining": "#C4BDB2",
  "burgundyandbluelining": "#662A30",
  "darkblueandbluelining": "#011749",
  "blackandbluelining": "#181818",
  "brownandbluelining": "#4E3B32",
  "creamandbluelining": "#DDC5A2",
  "orangeandbluelining": "#EF5215",
  "pinkandbluelining": "#B52E60",
  "greenandbluelining": "#5E9356",
  "darkgreenandbluelining": "#076827",
  "redandbluelining": "#8D1408",
  "darkgreenandeggplant": "#492735",
  "burgundyandburgundy": "#4A1B27",
  "silverandorange": "#A1AAAA",
  "creamandtaupe": "#7A5F4F",
  "blackandblack": "#373737",
  "greenandpink": "#42524C",
  "burgundyandgrass": "#674744",
  "darkblueanddarkblue": "#172363",
  "darkgreenanddarkgreen": "#457132",
  "eggplantandblack": "#36262C",
  "forestandlightgrey": "#3A3A2A",
  "lightpinkandlightgrey": "#C2A8A9",
  "lightpinkandpink": "#A83159",
  "purpleanddarkgrey": "#3D3145",
  "purpleandlightgrey": "#724880",
  "burgundyandforest": "#5A3432",
  "blackandorange": "#280A02",
  "blackanddarkbue": "#002B5E",
  "blackandcream": "#BCA085",
  "blackanddarkgreen": "#081D0C",
  "lightgreyandblack": "#1A1910",
  "creamandlightgrey": "#B2A189",
  "burgundyandblack": "#4C1B23",
  "darkblueandblue": "#0E5A9E",
  "orangeandlightpink": "#C6595C",
  "yellowandbrown": "#E0B81A",
  "greenandlightblue": "#3E8CB3",
  "redandlightblue": "#6F0D0D",
  "blackandlightpink": "#CE7186",
  "lightgreyandlightpink": "#D05A72",
  "redandlightgrey": "#954048",
  "burgundyandlightpink": "#652D36",
  "brownandpink": "#4A181F",
  "militarygreenandgreen": "#066A41",
  "burgundyandred": "#C10A20",
  "darkgreenandgreen": "#035A29",
  "militarygreenandorange": "#075640",
  "pinkanddarkgreen": "#03612D",
  "redandbrown": "#9A1308",
  "redandorange": "#C53D07",
  "blackandburgundy": "#0E0C0B",
  "blackandlightgrey": "#090607",
};

/*
 * Swatch paint pass.
 * Walks [data-color-label] nodes and sets --swatch-background from the
 * ThemeColors hashmap above. Label normalization matches old-theme:
 * `downcase | replace: ' ', ''`, e.g. "Bleu marine" -> "bleumarine".
 * Missing labels silently leave the swatch unpainted.
 */
(function () {
  function hexToRgb(hex) {
    var clean = String(hex).replace('#', '');
    if (clean.length === 3) {
      clean = clean[0] + clean[0] + clean[1] + clean[1] + clean[2] + clean[2];
    }
    var num = parseInt(clean, 16);
    if (isNaN(num)) return null;
    return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
  }

  function paint(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-color-label]:not([data-color-painted])');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var hex = ThemeColors[node.dataset.colorLabel];
      node.dataset.colorPainted = 'true';
      if (!hex) continue;
      var rgb = hexToRgb(hex);
      if (!rgb) continue;
      node.style.setProperty('--swatch-background', 'rgb(' + rgb.join(', ') + ')');
    }
  }

  window.BraderySwatches = { paint: paint, colors: ThemeColors };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); });
  } else {
    paint();
  }

  // Horizon replaces filter/grid DOM via the Section Rendering API. Observe
  // the body for added nodes and repaint any new swatches.
  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) paint(added[j]);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();